// Translation interface - all translation classes must implement this
export interface ITranslation {
  // Existing properties
  AppName: string;
  AppDescription: string;
  File: string;
  Edit: string;
  View: string;
  Image: string;
  Help: string;
  About: string;
  Warning: string;
  ConfirmUnsavedPattern: string;
  Tools: string;
  Name: string;
  Description: string;
  Category: string;
  AddCategory: string;
  EditCategory: string;
  DeleteCategory: string;
  Ok: string;
  Cancel: string;
  ConfirmDelete: string;
  AddPattern: string;
  EditPattern: string;
  PaletteEditor: string;
  SelectPaletteToEdit: string;
  NewPalette: string;
  DeletePalette: string;
  MyPalette: string;
  SelectACategory: string;
  SearchPattern: string;
  DeletePattern: string;
  OpenPattern: string;
  SavePattern: string;
  PrintPattern: string;
  BeadsPalette: string;
  BeadNumber: string;
  Count: string;
  Print: string;
  ExportPDF: string;
  Close: string;
  WordChart: string;
  ReplaceBeadWith: string;
  Apply: string;
  TransferImage: string;
  SelectPalette: string;
  Colors: string;
  PaletteNameEdit: string;
  OnlyFirstNBeadPalettes: string;
  Filter: string;
  Add: string;
  Remove: string;
  New: string;
  Open: string;
  Save: string;
  SaveAs: string;
  Undo: string;
  Redo: string;
  ZoomIn: string;
  ZoomOut: string;
  InsertImage: string;
  InsertImageTooltip: string;
  ShiftPatternLeft: string;
  ShiftPatternRight: string;
  ShiftPatternUp: string;
  ShiftPatternDown: string;
  RotatePatternLeft: string;
  RotatePatternRight: string;
  FlipPatternVertically: string;
  FlipPatternHorizontally: string;
  All: string;
  AllPatterns: string;
  ShowHideImage: string;
  RotateImageLeft: string;
  RotateImageRight: string;
  RotateRight: string;
  RotateLeft: string;
  PreEffect: string;
  Method: string;
  Dither: string;
  ShowSidebar: string;
  HideSidebar: string;
  TransformPattern: string;
  AddBead: string;
  Fill: string;
  RemoveBead: string;
  RemoveFill: string;
  PickBead: string;
  Pan: string;
  Profile: string;
  UnitOfMeasure: string;
  Inch: string;
  Cm: string;
  Mm: string;
  Rows: string;
  Columns: string;
  Stitch: string;
  Pattern: string;
  Palettes: string;
  Login: string;
  NotSignedIn: string;
  SignInWith: string;
  LoginWithFacebook: string;
  LoginWithGoogle: string;
  RotatedPatternOn: string;
  RotatedPatternOff: string;
  SignOut: string;
  Facebook: string;
  Google: string;
  Choose: string;
  ChoosePlan: string;
  ChangePlan: string;
  ChangePlanDone: string;
  Subscription: string;
  FREE: string;
  MONTHLY: string;
  YEARLY: string;
  SAVE20: string;
  NoCharge: string;
  PlanFreeDescription1: string;
  PlanFreeDescription2: string;
  PlanPaidDescription1: string;
  PlanPaidDescription2: string;
  BilledMonthly: string;
  BilledAnnually: string;
  WelcomeTour: string;
  VideoTutorial: string;
  Previous: string;
  Next: string;
  Page: string;
  PatternReader: string;
  ReaderSettings: string;
  ReaderColorLegend: string;
  ReaderPreviewTitle: string;
  ReaderPreviewMessage: string;
  ReaderUpgradeCta: string;
  ReaderTtsUnsupported: string;
  ReaderWaitPerBead: string;
  ReaderLanguage: string;
  ReaderPlay: string;
  ReaderPause: string;
  ReaderStop: string;
  ReaderReset: string;
  ReaderRow: string;
  ReaderKeyboardHint: string;
  ReaderSkipWait: string;
  ReaderNoRows: string;

  // New properties for hardcoded strings
  SavePatternReminder: string;
  EarlyWarningBannerTitle: string;
  EarlyWarningBannerText: string;
  ViewPlans: string;
  PatternsUsed: string;
  PatternsRemaining: string;
  JoinThousandsCreators: string;
  TrialInfoBanner: string;
  SevenDayFreeTrial: string;
  TrialPlusTwoMonthsFree: string;
  TwoMonthsFree: string;
  ThenMonthlyAfterTrial: string;
  ThenYearlyAfterTrial: string;
  OnlyPricePerMonth: string;
  MostPopular: string;
  SaveAmount: string;
  UnlimitedPatterns: string;
  HDExport: string;
  PDFSavePrint: string;
  PrioritySupport: string;
  PatternReaderPaidFeature: string;
  PrintPDF: string;
  StandardQuality: string;
  NoPDFExport: string;
  EmailSupportOnly: string;
  OnlyThreePatterns: string;
  StartFreeTrial: string;
  StartMonthlyPlan: string;
  StartYearlyPlan: string;
  CurrentPlan: string;
  ContinueFree: string;
  MoneyBackGuarantee: string;
  SecureCheckout: string;
  CancelAnytime: string;
  YourFreePlan: string;
  FreePlanStatus: string;
  PatternsCreated: string;
  NoPDFPrinting: string;
  CreateBeautifulPatterns: string;
  JoinThousandsCrafters: string;
  AutoSaveDesigns: string;
  PrintProfessionalGuides: string;
  AccessAnyDevice: string;
  StartThreeFreePatterns: string;
  Initializing: string;
  SignInWithGoogle: string;
  SecureAndPrivate: string;
  NoCreditCardRequired: string;
  GetStarted: string;
  AwesomeAllSet: string;
  YourPlan: string;
  FreeTrial: string;
  DaysLeft: string;
  TrialEndsIn: string;
  Day: string;
  Days: string;
  AllProFeaturesIncluded: string;
  UnlimitedPatternsHDExport: string;
  ContinueWithPro: string;
  KeepProBenefits: string;
  FreePlan: string;
  Active: string;
  PatternUsage: string;
  PatternRemaining: string;
  LimitReached: string;
  FreePlanLimited: string;
  UpgradeToPro: string;
  ProPlan: string;
  UnlimitedPatternsFeature: string;
  HDExportPrint: string;
  ManageSubscription: string;
  ManageSubscriptionHint: string;
  ProfileSettings: string;
  UsedAllFreePatterns: string;
  OnePatternRemaining: string;
  Language: string;
  NeedHelpCta: string;
  HelpPanelTitle: string;
  HelpPanelSubtitle: string;
  HelpFaqHeading: string;
  HelpContactHeading: string;
  HelpContactDescription: string;
  HelpContactEmailCta: string;
  HelpTutorialHeading: string;
  HelpTutorialDescription: string;
  HelpClose: string;
  HelpFaqUploadQuestion: string;
  HelpFaqUploadAnswer: string;
  HelpFaqSaveQuestion: string;
  HelpFaqSaveAnswer: string;
  HelpFaqExportQuestion: string;
  HelpFaqExportAnswer: string;
  HelpFaqTutorialQuestion: string;
  HelpFaqTutorialAnswer: string;

  // Onboarding hints
  OnboardingHintAdjustSettings: string;
  OnboardingHintGotIt: string;
  OnboardingHintUploadImage: string;
  OnboardingHintTransferImage: string;
  OnboardingHintSave: string;

  // Welcome modal
  WelcomeModalTitle: string;
  WelcomeModalSubtitle: string;
  WelcomeStep1Title: string;
  WelcomeStep1Description: string;
  WelcomeStep2Title: string;
  WelcomeStep2Description: string;
  WelcomeStep3Title: string;
  WelcomeStep3Description: string;
  WelcomeGuidanceNote: string;
  WelcomeShowMeHow: string;
  WelcomeWatchDemo: string;
  WelcomeExploreOwn: string;

  // Onboarding checklist
  ChecklistGetStarted: string;
  ChecklistMinimize: string;
  ChecklistCloseAndSkip: string;
  ChecklistAwesomeAllSet: string;
  ChecklistTapToOpen: string;
  ChecklistMenuOpened: string;
  ChecklistStepSignedIn: string;
  ChecklistStepUploadImage: string;
  ChecklistStepConvertPattern: string;
  ChecklistStepSaveWork: string;

  // Login page
  LoginPageTagline: string;
  LoginPageSubtitle: string;
  LoginFeatureAutoSave: string;
  LoginFeaturePrint: string;
  LoginFeatureDevices: string;
  LoginFeatureUnlimited: string;
  LoginInitializing: string;
  LoginSignInGoogle: string;
  LoginGoogleLogoAlt: string;
  LoginSecurePrivate: string;
  LoginStartFreePatterns: string;
  LoginOneClick: string;
  LoginInProgress: string;
  LoginCancelled: string;
  LoginNetworkError: string;
  LoginAuthError: string;
  LoginGenericError: string;
  TryAgain: string;

  // New pattern setup modal
  NewPatternTitle: string;
  NewPatternIntro: string;
  NewPatternQuickPreset: string;
  NewPatternCustomSize: string;
  NewPatternPopularProjects: string;
  NewPatternStitch: string;
  NewPatternColumns: string;
  NewPatternRows: string;
  NewPatternApproximateSize: string;
  NewPatternDimensionsNote: string;
  NewPatternCancel: string;
  NewPatternStart: string;
  PresetClassicPeyoteBracelet: string;
  PresetLoomBookmark: string;
  PresetBrickEarringsPair: string;
  PresetWidePeyoteCuff: string;
  PresetSmallLoomPanel: string;
  PresetBrickPendant: string;

  // Position image guide modal
  PositionImageTitle: string;
  PositionImageCloseTooltip: string;
  PositionImageHeading: string;
  PositionImageDragTitle: string;
  PositionImageDragDesc: string;
  PositionImageResizeTitle: string;
  PositionImageResizeDesc: string;
  PositionImageRotateTitle: string;
  PositionImageRotateDesc: string;
  PositionImageTipLabel: string;
  PositionImageTipText: string;
  PositionImageReady: string;
  PositionImageGotIt: string;

  // Video player modal
  VideoPlayerCloseAria: string;
  VideoPlayerNotSupported: string;

  // Cookie consent / Privacy
  CookieConsentTitle: string;
  CookieConsentMessage: string;
  CookieConsentDetails: string;
  CookieConsentAccept: string;
  CookieConsentDecline: string;

  // Palette mismatch error
  PaletteMismatchError: string;

  // Bead type selector in new pattern modal
  NewPatternBeadType: string;
  BeadTypeMiyukiDelica: string;
  BeadTypeMiyukiDelicaNote: string;
  BeadTypePreciosaRocailles: string;
  BeadTypePreciosaRocaillesNote: string;
}

// English Translation (default)
export class TranslationEnglish implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Bead Pattern Maker is a free beading tool used to create bead patterns easily and intuitively. It's a simple and powerful web tool to bring your imagination into life.";
  File = 'File';
  Edit = 'Edit';
  View = 'View';
  Image = 'Image';
  Help = 'Help';
  About = 'About';
  Warning = 'Warning';
  ConfirmUnsavedPattern = 'The current pattern is not saved. Are you sure you want to proceed?';
  Tools = 'Tools';
  Name = 'Name';
  Description = 'Description';
  Category = 'Category';
  AddCategory = 'Add Category';
  EditCategory = 'Edit Category';
  DeleteCategory = 'Delete Category';
  Ok = 'Ok';
  Cancel = 'Cancel';
  ConfirmDelete = 'Are you sure you want to delete {0}?';
  AddPattern = 'Add Pattern';
  EditPattern = 'Edit Pattern';
  PaletteEditor = 'Palette Editor';
  SelectPaletteToEdit = 'Select palette to edit';
  NewPalette = 'New Palette';
  DeletePalette = 'Delete Palette';
  MyPalette = 'My Palette';
  SelectACategory = 'Category';
  SearchPattern = 'Pattern';
  DeletePattern = 'Delete Pattern';
  OpenPattern = 'Open pattern...';
  SavePattern = 'Save pattern...';
  PrintPattern = 'Print Pattern';
  BeadsPalette = 'Beads Palette';
  BeadNumber = 'Bead #';
  Count = 'Count';
  Print = 'Print...';
  ExportPDF = 'Export PDF';
  Close = 'Close';
  WordChart = 'Word Chart';
  ReplaceBeadWith = 'Replace Bead with...';
  Apply = 'Apply';
  TransferImage = 'Transfer Image...';
  SelectPalette = 'Select palette...';
  Colors = 'Colors';
  PaletteNameEdit = 'Palette Name (Edit)';
  OnlyFirstNBeadPalettes = 'Only first {0} bead palettes';
  Filter = 'Filter...';
  Add = 'Add';
  Remove = 'Remove';
  New = 'New';
  Open = 'Open';
  Save = 'Save';
  SaveAs = 'Save as...';
  Undo = 'Undo';
  Redo = 'Redo';
  ZoomIn = 'Zoom In';
  ZoomOut = 'Zoom Out';
  InsertImage = 'Insert Image';
  InsertImageTooltip = 'Choose Photo (Take photo with camera app first, then select from gallery)';
  ShiftPatternLeft = 'Shift Pattern Left';
  ShiftPatternRight = 'Shift Pattern Right';
  ShiftPatternUp = 'Shift Pattern Up';
  ShiftPatternDown = 'Shift Pattern Down';
  RotatePatternLeft = 'Rotate Pattern Left';
  RotatePatternRight = 'Rotate Pattern Right';
  FlipPatternVertically = 'Flip Pattern Vertically';
  FlipPatternHorizontally = 'Flip Pattern Horizontally';
  All = 'All';
  AllPatterns = 'All patterns';
  ShowHideImage = 'Show/Hide Image';
  RotateImageLeft = 'Rotate Image Left';
  RotateImageRight = 'Rotate Image Right';
  RotateRight = 'Rotate Right';
  RotateLeft = 'Rotate Left';
  PreEffect = 'Pre Effect';
  Method = 'Method';
  Dither = 'Dither';
  ShowSidebar = 'Show Sidebar';
  HideSidebar = 'Hide Sidebar';
  TransformPattern = 'Transform Pattern';
  AddBead = 'Add Bead';
  Fill = 'Fill';
  RemoveBead = 'Remove Bead';
  RemoveFill = 'Remove Fill';
  PickBead = 'Pick Bead';
  Pan = 'Pan';
  Profile = 'Profile';
  UnitOfMeasure = 'Unit of measure';
  Inch = 'inch';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Rows';
  Columns = 'Columns';
  Stitch = 'Stitch';
  Pattern = 'Pattern';
  Palettes = 'Palettes';
  Login = 'Login';
  NotSignedIn = 'Not signed in';
  SignInWith = 'Sign in with';
  LoginWithFacebook = 'Login with Facebook';
  LoginWithGoogle = 'Login with Google';
  RotatedPatternOn = 'Rotated Pattern (On)';
  RotatedPatternOff = 'Rotated Pattern (Off)';
  SignOut = 'Sign out';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'CHOOSE';
  ChoosePlan = 'Choose Plan';
  ChangePlan = 'Change plan';
  ChangePlanDone = 'Plan changed. You may have to wait few minutes to see the changes applied.';
  Subscription = 'Subscription';
  FREE = 'FREE';
  MONTHLY = 'MONTHLY';
  YEARLY = 'YEARLY';
  SAVE20 = 'SAVE 20%';
  NoCharge = 'No charge';
  PlanFreeDescription1 = 'Save up to 3 patterns';
  PlanFreeDescription2 = 'No Print / PDF';
  PlanPaidDescription1 = 'Unlimited patterns';
  PlanPaidDescription2 = 'Print / PDF';
  BilledMonthly = 'Billed monthly';
  BilledAnnually = 'Billed annually';
  WelcomeTour = 'Welcome Tour';
  VideoTutorial = 'Video Tutorial';
  Previous = 'Previous';
  Next = 'Next';
  Page = 'Page';
  SavePatternReminder = "Don't forget to save your pattern!";
  EarlyWarningBannerTitle = "You've saved 2 of 3 free patterns!";
  EarlyWarningBannerText = "Upgrade now for unlimited patterns and premium features.";
  ViewPlans = 'View Plans';
  PatternsUsed = '{0} of 3 patterns used';
  PatternsRemaining = '({0} remaining)';
  JoinThousandsCreators = 'Join thousands of creators worldwide';
  TrialInfoBanner = 'Try Pro free for 7 days. Cancel anytime during trial. Card required.';
  SevenDayFreeTrial = '7-Day Free Trial';
  TrialPlusTwoMonthsFree = '7-DAY FREE TRIAL + 2 MONTHS FREE';
  TwoMonthsFree = 'GET 2 MONTHS FREE';
  ThenMonthlyAfterTrial = 'Then $5/month after trial';
  ThenYearlyAfterTrial = 'Then only $4.17/month after trial';
  OnlyPricePerMonth = 'Only $4.17/month';
  MostPopular = 'Most Popular';
  SaveAmount = 'Save $10/year';
  UnlimitedPatterns = 'Unlimited patterns';
  HDExport = 'HD export (300 DPI)';
  PDFSavePrint = 'PDF save & print';
  PrioritySupport = 'Priority support';
  PatternReaderPaidFeature = 'Pattern reader (save time + paper/ink)';
  PrintPDF = 'Print / PDF';
  StandardQuality = 'Standard quality';
  NoPDFExport = 'No PDF export';
  EmailSupportOnly = 'Email support only';
  OnlyThreePatterns = 'Only 3 patterns';
  StartFreeTrial = 'Start free trial';
  StartMonthlyPlan = 'Start monthly plan';
  StartYearlyPlan = 'Start yearly plan';
  CurrentPlan = 'Current plan';
  ContinueFree = 'Continue Free';
  MoneyBackGuarantee = '30-Day Money Back';
  SecureCheckout = 'Secure checkout';
  CancelAnytime = 'Cancel anytime';
  YourFreePlan = 'Your Free Plan';
  FreePlanStatus = 'Free Plan';
  PatternsCreated = 'patterns';
  NoPDFPrinting = 'No PDF/Print';
  CreateBeautifulPatterns = 'Create beautiful bead patterns in minutes';
  JoinThousandsCrafters = 'Join thousands of bead artists and crafters worldwide';
  AutoSaveDesigns = 'Auto-save your designs to the cloud';
  PrintProfessionalGuides = 'Print professional pattern guides';
  AccessAnyDevice = 'Access from any device';
  StartThreeFreePatterns = 'Start with 3 free patterns';
  Initializing = 'Initializing...';
  SignInWithGoogle = 'Sign in with Google';
  SecureAndPrivate = 'Secure & Private';
  NoCreditCardRequired = 'No credit card required';
  GetStarted = 'Get Started';
  AwesomeAllSet = "Awesome! You're all set!";
  YourPlan = 'Your Plan';
  FreeTrial = 'Free Trial';
  DaysLeft = 'days left';
  TrialEndsIn = 'Trial ends in';
  Day = 'day';
  Days = 'days';
  AllProFeaturesIncluded = 'All Pro features included';
  UnlimitedPatternsHDExport = 'Unlimited patterns & HD export';
  ContinueWithPro = 'Continue with Pro - From $5/mo';
  KeepProBenefits = 'Keep all Pro benefits after trial ends';
  FreePlan = 'Free Plan';
  Active = 'Active';
  PatternUsage = 'Pattern Usage';
  PatternRemaining = '{0} pattern{1} remaining';
  LimitReached = 'Limit reached - Upgrade to continue';
  FreePlanLimited = 'Free plan limited to 3 patterns';
  UpgradeToPro = 'Upgrade to Pro ($5/mo)';
  ProPlan = 'Pro Plan';
  UnlimitedPatternsFeature = 'Unlimited patterns';
  HDExportPrint = 'HD export & Print';
  ManageSubscription = 'Manage Subscription';
  ManageSubscriptionHint = 'Update payment, change plan, or cancel';
  ProfileSettings = 'Profile Settings';
  UsedAllFreePatterns = "You've used all 3 free patterns. Upgrade now to continue creating!";
  OnePatternRemaining = 'Only 1 free pattern remaining. Upgrade for unlimited patterns!';
  Language = 'Language';
  NeedHelpCta = 'Need help?';
  HelpPanelTitle = 'Need help?';
  HelpPanelSubtitle = 'Get help without leaving the app.';
  HelpFaqHeading = 'Quick answers';
  HelpContactHeading = 'Contact support';
  HelpContactDescription = 'If you find a bug or get stuck, send us a note and we will reply quickly.';
  HelpContactEmailCta = 'Email support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini tutorial';
  HelpTutorialDescription = 'Watch a 2-minute walkthrough of the main tools.';
  HelpClose = 'Close help';
  HelpFaqUploadQuestion = 'How do I upload my inspiration photo?';
  HelpFaqUploadAnswer = 'Click Image → Insert Image in the toolbar. You can upload any photo and convert it to a bead pattern.';
  HelpFaqSaveQuestion = 'How do I save my pattern?';
  HelpFaqSaveAnswer = 'Click the Save button in the toolbar. Your patterns are automatically saved to your account and can be accessed anytime from File → Open Pattern.';
  HelpFaqExportQuestion = 'How can I export or print the pattern?';
  HelpFaqExportAnswer = 'Click the Print button in the toolbar to generate high-resolution PDFs with bead charts, color legends, and shopping lists.';
  HelpFaqTutorialQuestion = 'Where can I learn the main tools quickly?';
  HelpFaqTutorialAnswer = 'Tap the Video Tutorial button below for a two-minute tour of uploading, converting, and saving.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Adjust the settings above, then tap Apply to convert';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Tap Image → Insert Image to add a photo';
  OnboardingHintTransferImage = 'Tap Image → Transfer Image to convert to beads';
  OnboardingHintSave = 'Tap File → Save to keep your work';

  // Welcome modal
  WelcomeModalTitle = 'Welcome to Bead Pattern Maker!';
  WelcomeModalSubtitle = "Let's create your first bead pattern from an image";
  WelcomeStep1Title = 'Upload Your Image';
  WelcomeStep1Description = 'Choose any photo you want to convert';
  WelcomeStep2Title = 'Position & Convert';
  WelcomeStep2Description = 'Adjust the image and convert it to beads';
  WelcomeStep3Title = 'Save Your Pattern';
  WelcomeStep3Description = 'Keep your creation for future use';
  WelcomeGuidanceNote = "We'll guide you through each step with helpful hints";
  WelcomeShowMeHow = 'Show Me How';
  WelcomeWatchDemo = 'Watch Quick Demo';
  WelcomeExploreOwn = "I'll Explore on My Own";

  // Onboarding checklist
  ChecklistGetStarted = 'Get Started';
  ChecklistMinimize = 'Minimize';
  ChecklistCloseAndSkip = 'Close and skip tutorial';
  ChecklistAwesomeAllSet = "🎉 Awesome! You're all set!";
  ChecklistTapToOpen = 'Tap to open menu';
  ChecklistMenuOpened = 'Tap the highlighted item';
  ChecklistStepSignedIn = 'Signed in';
  ChecklistStepUploadImage = 'Upload an image';
  ChecklistStepConvertPattern = 'Convert to pattern';
  ChecklistStepSaveWork = 'Save your work';

  // Login page
  LoginPageTagline = 'Create beautiful bead patterns in minutes';
  LoginPageSubtitle = 'Join thousands of bead artists and crafters worldwide';
  LoginFeatureAutoSave = 'Auto-save your designs to the cloud';
  LoginFeaturePrint = 'Print professional pattern guides';
  LoginFeatureDevices = 'Access from any device';
  LoginFeatureUnlimited = 'Create unlimited patterns';
  LoginInitializing = 'Initializing...';
  LoginSignInGoogle = 'Sign in with Google';
  LoginGoogleLogoAlt = 'Google logo';
  LoginSecurePrivate = 'Secure & Private';
  LoginStartFreePatterns = 'Start with 3 free patterns';
  LoginOneClick = 'One-click sign in — no passwords needed';
  LoginInProgress = 'Signing you in...';
  LoginCancelled = 'Sign in was cancelled. Please try again.';
  LoginNetworkError = 'Could not connect to Google. Please check your internet connection.';
  LoginAuthError = 'Authentication failed. Please try again.';
  LoginGenericError = 'Something went wrong. Please try again.';
  TryAgain = 'Try Again';

  // New pattern setup modal
  NewPatternTitle = 'Plan Your Pattern';
  NewPatternIntro = 'Choose a preset or customize the stitch and grid size for your pattern.';
  NewPatternQuickPreset = 'Quick Preset (Optional)';
  NewPatternCustomSize = 'Custom Size';
  NewPatternPopularProjects = 'Popular Projects';
  NewPatternStitch = 'Stitch';
  NewPatternColumns = 'Columns';
  NewPatternRows = 'Rows';
  NewPatternApproximateSize = 'Approximate size:';
  NewPatternDimensionsNote = 'Dimensions based on Miyuki Delica 11/0 beads (~1.8-2.1 mm). Measurements are approximate.';
  NewPatternCancel = 'Cancel';
  NewPatternStart = 'Start';
  PresetClassicPeyoteBracelet = 'Classic Peyote Bracelet';
  PresetLoomBookmark = 'Loom Bookmark';
  PresetBrickEarringsPair = 'Brick Earrings Pair';
  PresetWidePeyoteCuff = 'Wide Peyote Cuff';
  PresetSmallLoomPanel = 'Small Loom Panel';
  PresetBrickPendant = 'Brick Pendant';

  // Position image guide modal
  PositionImageTitle = 'Position Your Image';
  PositionImageCloseTooltip = 'Close';
  PositionImageHeading = 'How to Position Your Image';
  PositionImageDragTitle = 'Drag to Move:';
  PositionImageDragDesc = 'Click and drag the image to position it over the bead grid';
  PositionImageResizeTitle = 'Resize:';
  PositionImageResizeDesc = 'Drag the corner handles to make your image bigger or smaller';
  PositionImageRotateTitle = 'Rotate:';
  PositionImageRotateDesc = 'Use the toolbar buttons to rotate your image if needed';
  PositionImageTipLabel = 'Tip:';
  PositionImageTipText = 'Position your image to cover the area you want to convert into beads';
  PositionImageReady = 'When you\'re ready, click the Transfer Image button (⚡) in the toolbar';
  PositionImageGotIt = 'Got It!';

  // Video player modal
  VideoPlayerCloseAria = 'Close video';
  VideoPlayerNotSupported = 'Your browser does not support the video tag.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'We value your privacy';
  CookieConsentMessage = 'We use cookies and similar technologies to improve your experience, analyze site usage, and assist in our marketing efforts. By clicking "Accept", you consent to our use of cookies for analytics and session recording to help us improve our service.';
  CookieConsentDetails = 'We use PostHog for privacy-focused analytics. No data is sold to third parties. You can withdraw consent at any time in your profile settings.';
  CookieConsentAccept = 'Accept';
  CookieConsentDecline = 'Decline';

  PaletteMismatchError = 'Cannot mix beads from different bead types. This pattern uses {0}.';

  NewPatternBeadType = 'Bead Type';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Dimensions based on Miyuki Delica 11/0 beads (~1.6×1.35 mm). Measurements are approximate.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Dimensions based on Preciosa Rocailles 11/0 beads (~2.1 mm). Measurements are approximate.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

// Backward compatibility - keep TranslationBase as alias
export class TranslationBase extends TranslationEnglish {}

// TODO: Translate these classes to their respective languages
// For now, they extend English as placeholders

export class TranslationItalian implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Creatore di Schemi per Perline è uno strumento gratuito per creare schemi di perline facilmente e intuitivamente. È uno strumento web semplice e potente per dare vita alla tua immaginazione.";
  File = 'File';
  Edit = 'Modifica';
  View = 'Visualizza';
  Image = 'Immagine';
  Help = 'Aiuto';
  About = 'Informazioni';
  Warning = 'Avviso';
  ConfirmUnsavedPattern = 'Lo schema corrente non è salvato. Sei sicuro di voler procedere?';
  Tools = 'Strumenti';
  Name = 'Nome';
  Description = 'Descrizione';
  Category = 'Categoria';
  AddCategory = 'Aggiungi Categoria';
  EditCategory = 'Modifica Categoria';
  DeleteCategory = 'Elimina Categoria';
  Ok = 'Ok';
  Cancel = 'Annulla';
  ConfirmDelete = 'Sei sicuro di voler eliminare {0}?';
  AddPattern = 'Aggiungi Schema';
  EditPattern = 'Modifica Schema';
  PaletteEditor = 'Editor Palette';
  SelectPaletteToEdit = 'Seleziona palette da modificare';
  NewPalette = 'Nuova Palette';
  DeletePalette = 'Elimina Palette';
  MyPalette = 'La Mia Palette';
  SelectACategory = 'Categoria';
  SearchPattern = 'Schema';
  DeletePattern = 'Elimina Schema';
  OpenPattern = 'Apri schema...';
  SavePattern = 'Salva schema...';
  PrintPattern = 'Stampa Schema';
  BeadsPalette = 'Palette Perline';
  BeadNumber = 'Perlina n.';
  Count = 'Conteggio';
  Print = 'Stampa...';
  ExportPDF = 'Esporta PDF';
  Close = 'Chiudi';
  WordChart = 'Grafico Parole';
  ReplaceBeadWith = 'Sostituisci perlina con...';
  Apply = 'Applica';
  TransferImage = 'Trasferisci Immagine...';
  SelectPalette = 'Seleziona palette...';
  Colors = 'Colori';
  PaletteNameEdit = 'Nome Palette (Modifica)';
  OnlyFirstNBeadPalettes = 'Solo le prime {0} palette di perline';
  Filter = 'Filtra...';
  Add = 'Aggiungi';
  Remove = 'Rimuovi';
  New = 'Nuovo';
  Open = 'Apri';
  Save = 'Salva';
  SaveAs = 'Salva come...';
  Undo = 'Annulla';
  Redo = 'Ripeti';
  ZoomIn = 'Ingrandisci';
  ZoomOut = 'Riduci';
  InsertImage = 'Inserisci Immagine';
  InsertImageTooltip = 'Scegli Foto (Scatta prima la foto con l\'app fotocamera, poi seleziona dalla galleria)';
  ShiftPatternLeft = 'Sposta Schema a Sinistra';
  ShiftPatternRight = 'Sposta Schema a Destra';
  ShiftPatternUp = 'Sposta Schema in Alto';
  ShiftPatternDown = 'Sposta Schema in Basso';
  RotatePatternLeft = 'Ruota Schema a Sinistra';
  RotatePatternRight = 'Ruota Schema a Destra';
  FlipPatternVertically = 'Capovolgi Schema Verticalmente';
  FlipPatternHorizontally = 'Capovolgi Schema Orizzontalmente';
  All = 'Tutti';
  AllPatterns = 'Tutti gli schemi';
  ShowHideImage = 'Mostra/Nascondi Immagine';
  RotateImageLeft = 'Ruota Immagine a Sinistra';
  RotateImageRight = 'Ruota Immagine a Destra';
  RotateRight = 'Ruota a Destra';
  RotateLeft = 'Ruota a Sinistra';
  PreEffect = 'Pre Effetto';
  Method = 'Metodo';
  Dither = 'Dither';
  ShowSidebar = 'Mostra Barra Laterale';
  HideSidebar = 'Nascondi Barra Laterale';
  TransformPattern = 'Trasforma Schema';
  AddBead = 'Aggiungi Perlina';
  Fill = 'Riempi';
  RemoveBead = 'Rimuovi Perlina';
  RemoveFill = 'Rimuovi Riempimento';
  PickBead = 'Seleziona Perlina';
  Pan = 'Sposta';
  Profile = 'Profilo';
  UnitOfMeasure = 'Unità di misura';
  Inch = 'pollici';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Righe';
  Columns = 'Colonne';
  Stitch = 'Punto';
  Pattern = 'Schema';
  Palettes = 'Palette';
  Login = 'Accedi';
  NotSignedIn = 'Non connesso';
  SignInWith = 'Accedi con';
  LoginWithFacebook = 'Accedi con Facebook';
  LoginWithGoogle = 'Accedi con Google';
  RotatedPatternOn = 'Schema Ruotato (Attivo)';
  RotatedPatternOff = 'Schema Ruotato (Disattivo)';
  SignOut = 'Disconnetti';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'SCEGLI';
  ChoosePlan = 'Scegli piano';
  ChangePlan = 'Cambia piano';
  ChangePlanDone = 'Piano cambiato. Potrebbero essere necessari alcuni minuti per vedere le modifiche applicate.';
  Subscription = 'Abbonamento';
  FREE = 'GRATUITO';
  MONTHLY = 'MENSILE';
  YEARLY = 'ANNUALE';
  SAVE20 = 'RISPARMIA 20%';
  NoCharge = 'Nessun costo';
  PlanFreeDescription1 = 'Salva fino a 3 schemi';
  PlanFreeDescription2 = 'No Stampa / PDF';
  PlanPaidDescription1 = 'Schemi illimitati';
  PlanPaidDescription2 = 'Stampa / PDF';
  BilledMonthly = 'Fatturato mensilmente';
  BilledAnnually = 'Fatturato annualmente';
  WelcomeTour = 'Tour di Benvenuto';
  VideoTutorial = 'Video Tutorial';
  Previous = 'Precedente';
  Next = 'Successivo';
  Page = 'Pagina';
  SavePatternReminder = 'Non dimenticare di salvare il tuo schema!';
  EarlyWarningBannerTitle = 'Hai salvato 2 di 3 schemi gratuiti!';
  EarlyWarningBannerText = 'Aggiorna ora per schemi illimitati e funzionalità premium.';
  ViewPlans = 'Visualizza Piani';
  PatternsUsed = 'di 3 schemi utilizzati';
  PatternsRemaining = 'rimanenti';
  JoinThousandsCreators = 'Unisciti a migliaia di creatori in tutto il mondo';
  TrialInfoBanner = 'Prova Pro gratis per 7 giorni. Annulla in qualsiasi momento durante la prova. Carta richiesta.';
  SevenDayFreeTrial = 'Prova Gratuita di 7 Giorni';
  TrialPlusTwoMonthsFree = 'PROVA GRATUITA DI 7 GIORNI + 2 MESI GRATIS';
  TwoMonthsFree = 'OTTIENI 2 MESI GRATIS';
  ThenMonthlyAfterTrial = 'Poi €5/mese dopo la prova';
  ThenYearlyAfterTrial = 'Poi solo €4,17/mese dopo la prova';
  OnlyPricePerMonth = 'Solo €4,17/mese';
  MostPopular = 'Più Popolare';
  SaveAmount = 'Risparmia €10/anno';
  UnlimitedPatterns = 'Schemi illimitati';
  HDExport = 'Esportazione HD (300 DPI)';
  PDFSavePrint = 'Salvataggio e stampa PDF';
  PrioritySupport = 'Supporto prioritario';
  PatternReaderPaidFeature = 'Pattern Reader (risparmia tempo + carta/inchiostro)';
  PrintPDF = 'Stampa / PDF';
  StandardQuality = 'Qualità standard';
  NoPDFExport = 'Nessuna esportazione PDF';
  EmailSupportOnly = 'Solo supporto email';
  OnlyThreePatterns = 'Solo 3 schemi';
  StartFreeTrial = 'Inizia prova gratuita';
  StartMonthlyPlan = 'Inizia piano mensile';
  StartYearlyPlan = 'Inizia piano annuale';
  CurrentPlan = 'Piano corrente';
  ContinueFree = 'Continua Gratis';
  MoneyBackGuarantee = 'Garanzia Rimborso 30 Giorni';
  SecureCheckout = 'Pagamento sicuro';
  CancelAnytime = 'Annulla in qualsiasi momento';
  YourFreePlan = 'Il Tuo Piano Gratuito';
  FreePlanStatus = 'Piano Gratuito';
  PatternsCreated = 'schemi';
  NoPDFPrinting = 'No PDF/Stampa';
  CreateBeautifulPatterns = 'Crea bellissimi schemi per perline in pochi minuti';
  JoinThousandsCrafters = 'Unisciti a migliaia di artisti e artigiani delle perline in tutto il mondo';
  AutoSaveDesigns = 'Salvataggio automatico dei tuoi disegni nel cloud';
  PrintProfessionalGuides = 'Stampa guide di schemi professionali';
  AccessAnyDevice = 'Accedi da qualsiasi dispositivo';
  StartThreeFreePatterns = 'Inizia con 3 schemi gratuiti';
  Initializing = 'Inizializzazione...';
  SignInWithGoogle = 'Accedi con Google';
  SecureAndPrivate = 'Sicuro e Privato';
  NoCreditCardRequired = 'Nessuna carta di credito richiesta';
  GetStarted = 'Inizia';
  AwesomeAllSet = 'Fantastico! Sei pronto!';
  YourPlan = 'Il Tuo Piano';
  FreeTrial = 'Prova Gratuita';
  DaysLeft = 'giorni rimanenti';
  TrialEndsIn = 'La prova termina tra';
  Day = 'giorno';
  Days = 'giorni';
  AllProFeaturesIncluded = 'Tutte le funzionalità Pro incluse';
  UnlimitedPatternsHDExport = 'Schemi illimitati ed esportazione HD';
  ContinueWithPro = 'Continua con Pro - Da €5/mese';
  KeepProBenefits = 'Mantieni tutti i vantaggi Pro dopo la fine della prova';
  FreePlan = 'Piano Gratuito';
  Active = 'Attivo';
  PatternUsage = 'Utilizzo Schemi';
  PatternRemaining = 'schema rimanente';
  LimitReached = 'Limite raggiunto - Aggiorna per continuare';
  FreePlanLimited = 'Piano gratuito limitato a 3 schemi';
  UpgradeToPro = 'Aggiorna a Pro (€5/mese)';
  ProPlan = 'Piano Pro';
  UnlimitedPatternsFeature = 'Schemi illimitati';
  HDExportPrint = 'Esportazione HD e Stampa';
  ManageSubscription = 'Gestisci Abbonamento';
  ManageSubscriptionHint = 'Aggiorna pagamento, cambia piano o annulla';
  ProfileSettings = 'Impostazioni Profilo';
  UsedAllFreePatterns = 'Hai utilizzato tutti i 3 schemi gratuiti. Aggiorna ora per continuare a creare!';
  OnePatternRemaining = 'Solo 1 schema gratuito rimanente. Aggiorna per schemi illimitati!';
  Language = 'Lingua';
  NeedHelpCta = 'Serve aiuto?';
  HelpPanelTitle = 'Serve aiuto?';
  HelpPanelSubtitle = "Ricevi aiuto senza lasciare l'app.";
  HelpFaqHeading = 'Risposte rapide';
  HelpContactHeading = 'Contatta il supporto';
  HelpContactDescription = 'Se trovi un bug o resti bloccato, scrivici e ti aiuteremo velocemente.';
  HelpContactEmailCta = 'Scrivi a support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini tutorial';
  HelpTutorialDescription = 'Guarda un video di 2 minuti sugli strumenti principali.';
  HelpClose = 'Chiudi assistenza';
  HelpFaqUploadQuestion = 'Come carico la mia foto di riferimento?';
  HelpFaqUploadAnswer = 'Fai clic su Immagine → Inserisci Immagine nella toolbar. Puoi caricare qualsiasi foto e convertirla in uno schema di perline.';
  HelpFaqSaveQuestion = 'Come salvo il mio schema?';
  HelpFaqSaveAnswer = 'Fai clic sul pulsante Salva nella toolbar. I tuoi schemi vengono salvati automaticamente nel tuo account e possono essere aperti in qualsiasi momento da File → Apri Schema.';
  HelpFaqExportQuestion = 'Come posso esportare o stampare lo schema?';
  HelpFaqExportAnswer = 'Fai clic sul pulsante Stampa nella toolbar per generare PDF ad alta risoluzione con grafici delle perline, legende dei colori e liste della spesa.';
  HelpFaqTutorialQuestion = 'Dove posso imparare velocemente gli strumenti principali?';
  HelpFaqTutorialAnswer = 'Tocca il pulsante Video Tutorial qui sotto per un tour di due minuti su caricamento, conversione e salvataggio.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Regola le impostazioni sopra, poi tocca Applica per convertire';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Tocca Immagine → Inserisci Immagine';
  OnboardingHintTransferImage = 'Tocca Immagine → Trasferisci Immagine';
  OnboardingHintSave = 'Tocca File → Salva';

  // Welcome modal
  WelcomeModalTitle = 'Benvenuto in Bead Pattern Maker!';
  WelcomeModalSubtitle = 'Creiamo il tuo primo schema di perline da un\'immagine';
  WelcomeStep1Title = 'Carica la Tua Immagine';
  WelcomeStep1Description = 'Scegli una foto da convertire';
  WelcomeStep2Title = 'Posiziona e Converti';
  WelcomeStep2Description = 'Regola l\'immagine e convertila in perline';
  WelcomeStep3Title = 'Salva il Tuo Schema';
  WelcomeStep3Description = 'Conserva la tua creazione per usi futuri';
  WelcomeGuidanceNote = 'Ti guideremo attraverso ogni passaggio con suggerimenti utili';
  WelcomeShowMeHow = 'Mostrami Come';
  WelcomeWatchDemo = 'Guarda Demo Veloce';
  WelcomeExploreOwn = 'Esplorerò da Solo';

  // Onboarding checklist
  ChecklistGetStarted = 'Inizia';
  ChecklistMinimize = 'Minimizza';
  ChecklistCloseAndSkip = 'Chiudi e salta il tutorial';
  ChecklistAwesomeAllSet = '🎉 Fantastico! Sei pronto!';
  ChecklistTapToOpen = 'Tocca per aprire il menu';
  ChecklistMenuOpened = 'Tocca l\'elemento evidenziato';
  ChecklistStepSignedIn = 'Accesso effettuato';
  ChecklistStepUploadImage = 'Carica un\'immagine';
  ChecklistStepConvertPattern = 'Converti in schema';
  ChecklistStepSaveWork = 'Salva il tuo lavoro';

  // Login page
  LoginPageTagline = 'Crea bellissimi schemi di perline in pochi minuti';
  LoginPageSubtitle = 'Unisciti a migliaia di artisti e artigiani di perline in tutto il mondo';
  LoginFeatureAutoSave = 'Salvataggio automatico dei tuoi progetti sul cloud';
  LoginFeaturePrint = 'Stampa guide professionali per gli schemi';
  LoginFeatureDevices = 'Accedi da qualsiasi dispositivo';
  LoginFeatureUnlimited = 'Crea schemi illimitati';
  LoginInitializing = 'Inizializzazione...';
  LoginSignInGoogle = 'Accedi con Google';
  LoginGoogleLogoAlt = 'Logo Google';
  LoginSecurePrivate = 'Sicuro e Privato';
  LoginStartFreePatterns = 'Inizia con 3 schemi gratuiti';
  LoginOneClick = 'Accesso con un clic — nessuna password richiesta';
  LoginInProgress = 'Accesso in corso...';
  LoginCancelled = 'Accesso annullato. Riprova.';
  LoginNetworkError = 'Impossibile connettersi a Google. Controlla la connessione internet.';
  LoginAuthError = 'Autenticazione fallita. Riprova.';
  LoginGenericError = 'Qualcosa è andato storto. Riprova.';
  TryAgain = 'Riprova';

  // New pattern setup modal
  NewPatternTitle = 'Pianifica il Tuo Schema';
  NewPatternIntro = 'Scegli un preset o personalizza il punto e la dimensione della griglia per il tuo schema.';
  NewPatternQuickPreset = 'Preset Rapido (Opzionale)';
  NewPatternCustomSize = 'Dimensione Personalizzata';
  NewPatternPopularProjects = 'Progetti Popolari';
  NewPatternStitch = 'Punto';
  NewPatternColumns = 'Colonne';
  NewPatternRows = 'Righe';
  NewPatternApproximateSize = 'Dimensione approssimativa:';
  NewPatternDimensionsNote = 'Dimensioni basate su perline Miyuki Delica 11/0 (~1,8-2,1 mm). Le misure sono approssimative.';
  NewPatternCancel = 'Annulla';
  NewPatternStart = 'Inizia';
  PresetClassicPeyoteBracelet = 'Bracciale Peyote Classico';
  PresetLoomBookmark = 'Segnalibro Telaio';
  PresetBrickEarringsPair = 'Paio di Orecchini Brick';
  PresetWidePeyoteCuff = 'Polsino Peyote Largo';
  PresetSmallLoomPanel = 'Pannello Telaio Piccolo';
  PresetBrickPendant = 'Ciondolo Brick';

  // Position image guide modal
  PositionImageTitle = 'Posiziona la Tua Immagine';
  PositionImageCloseTooltip = 'Chiudi';
  PositionImageHeading = 'Come Posizionare la Tua Immagine';
  PositionImageDragTitle = 'Trascina per Spostare:';
  PositionImageDragDesc = 'Fai clic e trascina l\'immagine per posizionarla sulla griglia di perline';
  PositionImageResizeTitle = 'Ridimensiona:';
  PositionImageResizeDesc = 'Trascina le maniglie degli angoli per ingrandire o ridurre l\'immagine';
  PositionImageRotateTitle = 'Ruota:';
  PositionImageRotateDesc = 'Usa i pulsanti della barra degli strumenti per ruotare l\'immagine se necessario';
  PositionImageTipLabel = 'Suggerimento:';
  PositionImageTipText = 'Posiziona l\'immagine per coprire l\'area che vuoi convertire in perline';
  PositionImageReady = 'Quando sei pronto, fai clic sul pulsante Trasferisci Immagine (⚡) nella barra degli strumenti';
  PositionImageGotIt = 'Capito!';

  // Video player modal
  VideoPlayerCloseAria = 'Chiudi video';
  VideoPlayerNotSupported = 'Il tuo browser non supporta il tag video.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Rispettiamo la tua privacy';
  CookieConsentMessage = 'Utilizziamo cookie e tecnologie simili per migliorare la tua esperienza, analizzare l\'utilizzo del sito e supportare i nostri sforzi di marketing. Cliccando "Accetta", acconsenti all\'uso dei cookie per analisi e registrazione delle sessioni per aiutarci a migliorare il nostro servizio.';
  CookieConsentDetails = 'Utilizziamo PostHog per analisi focalizzate sulla privacy. Nessun dato viene venduto a terze parti. Puoi revocare il consenso in qualsiasi momento nelle impostazioni del profilo.';
  CookieConsentAccept = 'Accetta';
  CookieConsentDecline = 'Rifiuta';

  PaletteMismatchError = 'Non è possibile mescolare perline di tipi diversi. Questo schema utilizza {0}.';

  NewPatternBeadType = 'Tipo di Perlina';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Dimensioni basate su perline Miyuki Delica 11/0 (~1,6×1,35 mm). Le misure sono approssimative.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Dimensioni basate su perline Preciosa Rocailles 11/0 (~2,1 mm). Le misure sono approssimative.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

export class TranslationGerman implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Perlen Muster Maker ist ein kostenloses Werkzeug zum einfachen und intuitiven Erstellen von Perlenmustern. Es ist ein einfaches und leistungsstarkes Web-Tool, um Ihre Fantasie zum Leben zu erwecken.";
  File = 'Datei';
  Edit = 'Bearbeiten';
  View = 'Ansicht';
  Image = 'Bild';
  Help = 'Hilfe';
  About = 'Über';
  Warning = 'Warnung';
  ConfirmUnsavedPattern = 'Das aktuelle Muster ist nicht gespeichert. Möchten Sie wirklich fortfahren?';
  Tools = 'Werkzeuge';
  Name = 'Name';
  Description = 'Beschreibung';
  Category = 'Kategorie';
  AddCategory = 'Kategorie hinzufügen';
  EditCategory = 'Kategorie bearbeiten';
  DeleteCategory = 'Kategorie löschen';
  Ok = 'Ok';
  Cancel = 'Abbrechen';
  ConfirmDelete = 'Möchten Sie {0} wirklich löschen?';
  AddPattern = 'Muster hinzufügen';
  EditPattern = 'Muster bearbeiten';
  PaletteEditor = 'Paletten-Editor';
  SelectPaletteToEdit = 'Palette zum Bearbeiten auswählen';
  NewPalette = 'Neue Palette';
  DeletePalette = 'Palette löschen';
  MyPalette = 'Meine Palette';
  SelectACategory = 'Kategorie';
  SearchPattern = 'Muster';
  DeletePattern = 'Muster löschen';
  OpenPattern = 'Muster öffnen...';
  SavePattern = 'Muster speichern...';
  PrintPattern = 'Muster drucken';
  BeadsPalette = 'Perlen-Palette';
  BeadNumber = 'Perle Nr.';
  Count = 'Anzahl';
  Print = 'Drucken...';
  ExportPDF = 'PDF exportieren';
  Close = 'Schließen';
  WordChart = 'Wort-Diagramm';
  ReplaceBeadWith = 'Perle ersetzen mit...';
  Apply = 'Anwenden';
  TransferImage = 'Bild übertragen...';
  SelectPalette = 'Palette auswählen...';
  Colors = 'Farben';
  PaletteNameEdit = 'Palettenname (Bearbeiten)';
  OnlyFirstNBeadPalettes = 'Nur die ersten {0} Perlen-Paletten';
  Filter = 'Filter...';
  Add = 'Hinzufügen';
  Remove = 'Entfernen';
  New = 'Neu';
  Open = 'Öffnen';
  Save = 'Speichern';
  SaveAs = 'Speichern unter...';
  Undo = 'Rückgängig';
  Redo = 'Wiederholen';
  ZoomIn = 'Vergrößern';
  ZoomOut = 'Verkleinern';
  InsertImage = 'Bild einfügen';
  InsertImageTooltip = 'Foto auswählen (Machen Sie zuerst ein Foto mit der Kamera-App und wählen Sie es dann aus der Galerie aus)';
  ShiftPatternLeft = 'Muster nach links verschieben';
  ShiftPatternRight = 'Muster nach rechts verschieben';
  ShiftPatternUp = 'Muster nach oben verschieben';
  ShiftPatternDown = 'Muster nach unten verschieben';
  RotatePatternLeft = 'Muster nach links drehen';
  RotatePatternRight = 'Muster nach rechts drehen';
  FlipPatternVertically = 'Muster vertikal spiegeln';
  FlipPatternHorizontally = 'Muster horizontal spiegeln';
  All = 'Alle';
  AllPatterns = 'Alle Muster';
  ShowHideImage = 'Bild anzeigen/ausblenden';
  RotateImageLeft = 'Bild nach links drehen';
  RotateImageRight = 'Bild nach rechts drehen';
  RotateRight = 'Nach rechts drehen';
  RotateLeft = 'Nach links drehen';
  PreEffect = 'Vor-Effekt';
  Method = 'Methode';
  Dither = 'Dithering';
  ShowSidebar = 'Seitenleiste anzeigen';
  HideSidebar = 'Seitenleiste ausblenden';
  TransformPattern = 'Muster transformieren';
  AddBead = 'Perle hinzufügen';
  Fill = 'Füllen';
  RemoveBead = 'Perle entfernen';
  RemoveFill = 'Füllung entfernen';
  PickBead = 'Perle auswählen';
  Pan = 'Verschieben';
  Profile = 'Profil';
  UnitOfMeasure = 'Maßeinheit';
  Inch = 'Zoll';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Zeilen';
  Columns = 'Spalten';
  Stitch = 'Stich';
  Pattern = 'Muster';
  Palettes = 'Paletten';
  Login = 'Anmelden';
  NotSignedIn = 'Nicht angemeldet';
  SignInWith = 'Anmelden mit';
  LoginWithFacebook = 'Mit Facebook anmelden';
  LoginWithGoogle = 'Mit Google anmelden';
  RotatedPatternOn = 'Gedrehtes Muster (Ein)';
  RotatedPatternOff = 'Gedrehtes Muster (Aus)';
  SignOut = 'Abmelden';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'WÄHLEN';
  ChoosePlan = 'Plan wählen';
  ChangePlan = 'Plan ändern';
  ChangePlanDone = 'Plan geändert. Es kann einige Minuten dauern, bis die Änderungen angewendet werden.';
  Subscription = 'Abonnement';
  FREE = 'KOSTENLOS';
  MONTHLY = 'MONATLICH';
  YEARLY = 'JÄHRLICH';
  SAVE20 = '20% SPAREN';
  NoCharge = 'Keine Gebühr';
  PlanFreeDescription1 = 'Bis zu 3 Muster speichern';
  PlanFreeDescription2 = 'Kein Druck / PDF';
  PlanPaidDescription1 = 'Unbegrenzte Muster';
  PlanPaidDescription2 = 'Druck / PDF';
  BilledMonthly = 'Monatlich abgerechnet';
  BilledAnnually = 'Jährlich abgerechnet';
  WelcomeTour = 'Willkommenstour';
  VideoTutorial = 'Video-Tutorial';
  Previous = 'Zurück';
  Next = 'Weiter';
  Page = 'Seite';
  SavePatternReminder = 'Vergessen Sie nicht, Ihr Muster zu speichern!';
  EarlyWarningBannerTitle = 'Sie haben 2 von 3 kostenlosen Mustern gespeichert!';
  EarlyWarningBannerText = 'Jetzt upgraden für unbegrenzte Muster und Premium-Funktionen.';
  ViewPlans = 'Pläne anzeigen';
  PatternsUsed = 'von 3 Mustern verwendet';
  PatternsRemaining = 'verbleibend';
  JoinThousandsCreators = 'Schließen Sie sich Tausenden von Kreativen weltweit an';
  TrialInfoBanner = '7 Tage Pro kostenlos testen. Jederzeit während der Testphase kündbar. Karte erforderlich.';
  SevenDayFreeTrial = '7-Tage-Testversion';
  TrialPlusTwoMonthsFree = '7-TAGE-TESTVERSION + 2 MONATE GRATIS';
  TwoMonthsFree = '2 MONATE GRATIS';
  ThenMonthlyAfterTrial = 'Dann 5€/Monat nach Testphase';
  ThenYearlyAfterTrial = 'Dann nur 4,17€/Monat nach Testphase';
  OnlyPricePerMonth = 'Nur 4,17€/Monat';
  MostPopular = 'Beliebteste';
  SaveAmount = 'Sparen Sie 10€/Jahr';
  UnlimitedPatterns = 'Unbegrenzte Muster';
  HDExport = 'HD-Export (300 DPI)';
  PDFSavePrint = 'PDF speichern & drucken';
  PrioritySupport = 'Prioritäts-Support';
  PatternReaderPaidFeature = 'Pattern Reader (spart Zeit + Papier/Tinte)';
  PrintPDF = 'Druck / PDF';
  StandardQuality = 'Standardqualität';
  NoPDFExport = 'Kein PDF-Export';
  EmailSupportOnly = 'Nur E-Mail-Support';
  OnlyThreePatterns = 'Nur 3 Muster';
  StartFreeTrial = 'Testversion starten';
  StartMonthlyPlan = 'Monatsplan starten';
  StartYearlyPlan = 'Jahresplan starten';
  CurrentPlan = 'Aktueller Plan';
  ContinueFree = 'Kostenlos fortfahren';
  MoneyBackGuarantee = '30-Tage-Geld-zurück-Garantie';
  SecureCheckout = 'Sichere Zahlung';
  CancelAnytime = 'Jederzeit kündbar';
  YourFreePlan = 'Ihr Kostenloser Plan';
  FreePlanStatus = 'Kostenloser Plan';
  PatternsCreated = 'Muster';
  NoPDFPrinting = 'Kein PDF/Druck';
  CreateBeautifulPatterns = 'Erstellen Sie in Minuten wunderschöne Perlenmuster';
  JoinThousandsCrafters = 'Schließen Sie sich Tausenden von Perlenkünstlern und Handwerkern weltweit an';
  AutoSaveDesigns = 'Automatisches Speichern Ihrer Designs in der Cloud';
  PrintProfessionalGuides = 'Professionelle Musteranleitungen drucken';
  AccessAnyDevice = 'Von jedem Gerät aus zugreifen';
  StartThreeFreePatterns = 'Beginnen Sie mit 3 kostenlosen Mustern';
  Initializing = 'Initialisierung...';
  SignInWithGoogle = 'Mit Google anmelden';
  SecureAndPrivate = 'Sicher & Privat';
  NoCreditCardRequired = 'Keine Kreditkarte erforderlich';
  GetStarted = 'Loslegen';
  AwesomeAllSet = 'Großartig! Sie sind startklar!';
  YourPlan = 'Ihr Plan';
  FreeTrial = 'Kostenlose Testversion';
  DaysLeft = 'Tage verbleibend';
  TrialEndsIn = 'Testphase endet in';
  Day = 'Tag';
  Days = 'Tage';
  AllProFeaturesIncluded = 'Alle Pro-Funktionen enthalten';
  UnlimitedPatternsHDExport = 'Unbegrenzte Muster & HD-Export';
  ContinueWithPro = 'Mit Pro fortfahren - Ab 5€/Monat';
  KeepProBenefits = 'Behalten Sie alle Pro-Vorteile nach Ende der Testphase';
  FreePlan = 'Kostenloser Plan';
  Active = 'Aktiv';
  PatternUsage = 'Musternutzung';
  PatternRemaining = 'Muster verbleibend';
  LimitReached = 'Limit erreicht - Upgraden Sie, um fortzufahren';
  FreePlanLimited = 'Kostenloser Plan auf 3 Muster begrenzt';
  UpgradeToPro = 'Auf Pro upgraden (5€/Monat)';
  ProPlan = 'Pro-Plan';
  UnlimitedPatternsFeature = 'Unbegrenzte Muster';
  HDExportPrint = 'HD-Export & Druck';
  ManageSubscription = 'Abonnement verwalten';
  ManageSubscriptionHint = 'Zahlung aktualisieren, Plan ändern oder kündigen';
  ProfileSettings = 'Profileinstellungen';
  UsedAllFreePatterns = 'Sie haben alle 3 kostenlosen Muster verwendet. Upgraden Sie jetzt, um weiter zu erstellen!';
  OnePatternRemaining = 'Nur 1 kostenloses Muster verbleibend. Upgraden Sie für unbegrenzte Muster!';
  Language = 'Sprache';
  NeedHelpCta = 'Brauchen Sie Hilfe?';
  HelpPanelTitle = 'Brauchen Sie Hilfe?';
  HelpPanelSubtitle = 'Hilfe erhalten, ohne die App zu verlassen.';
  HelpFaqHeading = 'Schnelle Antworten';
  HelpContactHeading = 'Support kontaktieren';
  HelpContactDescription = 'Wenn ein Fehler auftritt oder Sie feststecken, schreiben Sie uns und wir melden uns schnell.';
  HelpContactEmailCta = 'E-Mail an support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini-Tutorial';
  HelpTutorialDescription = 'Sehen Sie sich ein 2-minütiges Video zu den wichtigsten Werkzeugen an.';
  HelpClose = 'Hilfe schließen';
  HelpFaqUploadQuestion = 'Wie lade ich mein Referenzfoto hoch?';
  HelpFaqUploadAnswer = 'Klicken Sie auf Bild → Bild einfügen in der Toolbar. Sie können jedes Foto hochladen und in ein Perlenmuster umwandeln.';
  HelpFaqSaveQuestion = 'Wie speichere ich mein Muster?';
  HelpFaqSaveAnswer = 'Klicken Sie auf den Speichern-Button in der Toolbar. Ihre Muster werden automatisch in Ihrem Konto gespeichert und können jederzeit über Datei → Muster öffnen aufgerufen werden.';
  HelpFaqExportQuestion = 'Wie kann ich das Muster exportieren oder drucken?';
  HelpFaqExportAnswer = 'Klicken Sie auf den Drucken-Button in der Toolbar, um hochauflösende PDFs mit Perlendiagrammen, Farblegende und Einkaufslisten zu erstellen.';
  HelpFaqTutorialQuestion = 'Wo lerne ich die wichtigsten Werkzeuge am schnellsten?';
  HelpFaqTutorialAnswer = 'Tippen Sie unten auf den Video-Tutorial-Button für einen zweiminütigen Überblick über Hochladen, Umwandeln und Speichern.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Einstellungen oben anpassen, dann auf Anwenden tippen';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Tippe Bild → Bild einfügen';
  OnboardingHintTransferImage = 'Tippe Bild → Bild übertragen';
  OnboardingHintSave = 'Tippe Datei → Speichern';

  // Welcome modal
  WelcomeModalTitle = 'Willkommen bei Bead Pattern Maker!';
  WelcomeModalSubtitle = 'Erstellen Sie Ihr erstes Perlenmuster aus einem Bild';
  WelcomeStep1Title = 'Bild Hochladen';
  WelcomeStep1Description = 'Wählen Sie ein Foto zum Konvertieren';
  WelcomeStep2Title = 'Positionieren & Konvertieren';
  WelcomeStep2Description = 'Passen Sie das Bild an und konvertieren Sie es';
  WelcomeStep3Title = 'Muster Speichern';
  WelcomeStep3Description = 'Bewahren Sie Ihre Kreation für später auf';
  WelcomeGuidanceNote = 'Wir führen Sie durch jeden Schritt mit hilfreichen Hinweisen';
  WelcomeShowMeHow = 'Zeig mir wie';
  WelcomeWatchDemo = 'Kurze Demo ansehen';
  WelcomeExploreOwn = 'Ich erkunde selbst';

  // Onboarding checklist
  ChecklistGetStarted = 'Loslegen';
  ChecklistMinimize = 'Minimieren';
  ChecklistCloseAndSkip = 'Schließen und Tutorial überspringen';
  ChecklistAwesomeAllSet = '🎉 Großartig! Sie sind bereit!';
  ChecklistTapToOpen = 'Tippen Sie, um das Menü zu öffnen';
  ChecklistMenuOpened = 'Tippen Sie auf das hervorgehobene Element';
  ChecklistStepSignedIn = 'Angemeldet';
  ChecklistStepUploadImage = 'Bild hochladen';
  ChecklistStepConvertPattern = 'In Muster konvertieren';
  ChecklistStepSaveWork = 'Ihre Arbeit speichern';

  // Login page
  LoginPageTagline = 'Erstellen Sie in Minuten wunderschöne Perlenmuster';
  LoginPageSubtitle = 'Schließen Sie sich Tausenden von Perlenkünstlern und Handwerkern weltweit an';
  LoginFeatureAutoSave = 'Speichern Sie Ihre Designs automatisch in der Cloud';
  LoginFeaturePrint = 'Drucken Sie professionelle Musteranleitungen';
  LoginFeatureDevices = 'Zugriff von jedem Gerät';
  LoginFeatureUnlimited = 'Erstellen Sie unbegrenzt Muster';
  LoginInitializing = 'Initialisierung...';
  LoginSignInGoogle = 'Mit Google anmelden';
  LoginGoogleLogoAlt = 'Google-Logo';
  LoginSecurePrivate = 'Sicher & Privat';
  LoginStartFreePatterns = 'Beginnen Sie mit 3 kostenlosen Mustern';
  LoginOneClick = 'Ein-Klick-Anmeldung — kein Passwort erforderlich';
  LoginInProgress = 'Anmeldung läuft...';
  LoginCancelled = 'Anmeldung abgebrochen. Bitte versuchen Sie es erneut.';
  LoginNetworkError = 'Verbindung zu Google nicht möglich. Bitte überprüfen Sie Ihre Internetverbindung.';
  LoginAuthError = 'Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.';
  LoginGenericError = 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.';
  TryAgain = 'Erneut versuchen';

  // New pattern setup modal
  NewPatternTitle = 'Planen Sie Ihr Muster';
  NewPatternIntro = 'Wählen Sie eine Vorlage oder passen Sie die Stichgröße und Rastergröße für Ihr Muster an.';
  NewPatternQuickPreset = 'Schnellvorlage (Optional)';
  NewPatternCustomSize = 'Benutzerdefinierte Größe';
  NewPatternPopularProjects = 'Beliebte Projekte';
  NewPatternStitch = 'Stich';
  NewPatternColumns = 'Spalten';
  NewPatternRows = 'Reihen';
  NewPatternApproximateSize = 'Ungefähre Größe:';
  NewPatternDimensionsNote = 'Abmessungen basierend auf Miyuki Delica 11/0 Perlen (~1,8-2,1 mm). Messungen sind ungefähr.';
  NewPatternCancel = 'Abbrechen';
  NewPatternStart = 'Starten';
  PresetClassicPeyoteBracelet = 'Klassisches Peyote Armband';
  PresetLoomBookmark = 'Webstuhl Lesezeichen';
  PresetBrickEarringsPair = 'Brick Ohrringe Paar';
  PresetWidePeyoteCuff = 'Breite Peyote Manschette';
  PresetSmallLoomPanel = 'Kleines Webstuhl Panel';
  PresetBrickPendant = 'Brick Anhänger';

  // Position image guide modal
  PositionImageTitle = 'Positionieren Sie Ihr Bild';
  PositionImageCloseTooltip = 'Schließen';
  PositionImageHeading = 'So positionieren Sie Ihr Bild';
  PositionImageDragTitle = 'Ziehen zum Verschieben:';
  PositionImageDragDesc = 'Klicken und ziehen Sie das Bild, um es über dem Perlenraster zu positionieren';
  PositionImageResizeTitle = 'Größe ändern:';
  PositionImageResizeDesc = 'Ziehen Sie die Eckgriffe, um Ihr Bild größer oder kleiner zu machen';
  PositionImageRotateTitle = 'Drehen:';
  PositionImageRotateDesc = 'Verwenden Sie die Symbolleistenschaltflächen, um Ihr Bild bei Bedarf zu drehen';
  PositionImageTipLabel = 'Tipp:';
  PositionImageTipText = 'Positionieren Sie Ihr Bild, um den Bereich abzudecken, den Sie in Perlen umwandeln möchten';
  PositionImageReady = 'Wenn Sie bereit sind, klicken Sie auf die Schaltfläche Bild übertragen (⚡) in der Symbolleiste';
  PositionImageGotIt = 'Verstanden!';

  // Video player modal
  VideoPlayerCloseAria = 'Video schließen';
  VideoPlayerNotSupported = 'Ihr Browser unterstützt das Video-Tag nicht.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Ihre Privatsphäre ist uns wichtig';
  CookieConsentMessage = 'Wir verwenden Cookies und ähnliche Technologien, um Ihre Erfahrung zu verbessern, die Website-Nutzung zu analysieren und unsere Marketingbemühungen zu unterstützen. Durch Klicken auf "Akzeptieren" stimmen Sie der Verwendung von Cookies für Analysen und Sitzungsaufzeichnung zu, um unseren Service zu verbessern.';
  CookieConsentDetails = 'Wir verwenden PostHog für datenschutzorientierte Analysen. Keine Daten werden an Dritte verkauft. Sie können die Einwilligung jederzeit in Ihren Profileinstellungen widerrufen.';
  CookieConsentAccept = 'Akzeptieren';
  CookieConsentDecline = 'Ablehnen';

  PaletteMismatchError = 'Perlen verschiedener Perlentypen können nicht gemischt werden. Dieses Muster verwendet {0}.';

  NewPatternBeadType = 'Perlentyp';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Abmessungen basierend auf Miyuki Delica 11/0 Perlen (~1,6×1,35 mm). Messungen sind ungefähr.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Abmessungen basierend auf Preciosa Rocailles 11/0 Perlen (~2,1 mm). Messungen sind ungefähr.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

export class TranslationFrench implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Créateur de Motifs de Perles est un outil gratuit pour créer des motifs de perles facilement et intuitivement. C'est un outil web simple et puissant pour donner vie à votre imagination.";
  File = 'Fichier';
  Edit = 'Éditer';
  View = 'Affichage';
  Image = 'Image';
  Help = 'Aide';
  About = 'À propos';
  Warning = 'Avertissement';
  ConfirmUnsavedPattern = 'Le motif actuel n\'est pas enregistré. Êtes-vous sûr de vouloir continuer?';
  Tools = 'Outils';
  Name = 'Nom';
  Description = 'Description';
  Category = 'Catégorie';
  AddCategory = 'Ajouter une catégorie';
  EditCategory = 'Modifier la catégorie';
  DeleteCategory = 'Supprimer la catégorie';
  Ok = 'Ok';
  Cancel = 'Annuler';
  ConfirmDelete = 'Êtes-vous sûr de vouloir supprimer {0}?';
  AddPattern = 'Ajouter un motif';
  EditPattern = 'Modifier le motif';
  PaletteEditor = 'Éditeur de palette';
  SelectPaletteToEdit = 'Sélectionner une palette à modifier';
  NewPalette = 'Nouvelle palette';
  DeletePalette = 'Supprimer la palette';
  MyPalette = 'Ma palette';
  SelectACategory = 'Catégorie';
  SearchPattern = 'Motif';
  DeletePattern = 'Supprimer le motif';
  OpenPattern = 'Ouvrir le motif...';
  SavePattern = 'Enregistrer le motif...';
  PrintPattern = 'Imprimer le motif';
  BeadsPalette = 'Palette de perles';
  BeadNumber = 'Perle n°';
  Count = 'Nombre';
  Print = 'Imprimer...';
  ExportPDF = 'Exporter en PDF';
  Close = 'Fermer';
  WordChart = 'Graphique de mots';
  ReplaceBeadWith = 'Remplacer la perle par...';
  Apply = 'Appliquer';
  TransferImage = 'Transférer l\'image...';
  SelectPalette = 'Sélectionner une palette...';
  Colors = 'Couleurs';
  PaletteNameEdit = 'Nom de la palette (Éditer)';
  OnlyFirstNBeadPalettes = 'Seulement les {0} premières palettes de perles';
  Filter = 'Filtrer...';
  Add = 'Ajouter';
  Remove = 'Supprimer';
  New = 'Nouveau';
  Open = 'Ouvrir';
  Save = 'Enregistrer';
  SaveAs = 'Enregistrer sous...';
  Undo = 'Annuler';
  Redo = 'Refaire';
  ZoomIn = 'Zoomer';
  ZoomOut = 'Dézoomer';
  InsertImage = 'Insérer une image';
  InsertImageTooltip = 'Choisir une photo (Prenez d\'abord une photo avec l\'application appareil photo, puis sélectionnez-la dans la galerie)';
  ShiftPatternLeft = 'Décaler le motif à gauche';
  ShiftPatternRight = 'Décaler le motif à droite';
  ShiftPatternUp = 'Décaler le motif vers le haut';
  ShiftPatternDown = 'Décaler le motif vers le bas';
  RotatePatternLeft = 'Pivoter le motif à gauche';
  RotatePatternRight = 'Pivoter le motif à droite';
  FlipPatternVertically = 'Retourner le motif verticalement';
  FlipPatternHorizontally = 'Retourner le motif horizontalement';
  All = 'Tous';
  AllPatterns = 'Tous les motifs';
  ShowHideImage = 'Afficher/Masquer l\'image';
  RotateImageLeft = 'Pivoter l\'image à gauche';
  RotateImageRight = 'Pivoter l\'image à droite';
  RotateRight = 'Pivoter à droite';
  RotateLeft = 'Pivoter à gauche';
  PreEffect = 'Pré-effet';
  Method = 'Méthode';
  Dither = 'Tramage';
  ShowSidebar = 'Afficher la barre latérale';
  HideSidebar = 'Masquer la barre latérale';
  TransformPattern = 'Transformer le motif';
  AddBead = 'Ajouter une perle';
  Fill = 'Remplir';
  RemoveBead = 'Supprimer la perle';
  RemoveFill = 'Supprimer le remplissage';
  PickBead = 'Sélectionner une perle';
  Pan = 'Déplacer';
  Profile = 'Profil';
  UnitOfMeasure = 'Unité de mesure';
  Inch = 'pouce';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Lignes';
  Columns = 'Colonnes';
  Stitch = 'Point';
  Pattern = 'Motif';
  Palettes = 'Palettes';
  Login = 'Connexion';
  NotSignedIn = 'Non connecté';
  SignInWith = 'Se connecter avec';
  LoginWithFacebook = 'Se connecter avec Facebook';
  LoginWithGoogle = 'Se connecter avec Google';
  RotatedPatternOn = 'Motif pivoté (Activé)';
  RotatedPatternOff = 'Motif pivoté (Désactivé)';
  SignOut = 'Se déconnecter';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'CHOISIR';
  ChoosePlan = 'Choisir un plan';
  ChangePlan = 'Changer de plan';
  ChangePlanDone = 'Plan changé. Cela peut prendre quelques minutes pour voir les modifications appliquées.';
  Subscription = 'Abonnement';
  FREE = 'GRATUIT';
  MONTHLY = 'MENSUEL';
  YEARLY = 'ANNUEL';
  SAVE20 = 'ÉCONOMISEZ 20%';
  NoCharge = 'Aucun frais';
  PlanFreeDescription1 = 'Enregistrer jusqu\'à 3 motifs';
  PlanFreeDescription2 = 'Pas d\'impression / PDF';
  PlanPaidDescription1 = 'Motifs illimités';
  PlanPaidDescription2 = 'Impression / PDF';
  BilledMonthly = 'Facturé mensuellement';
  BilledAnnually = 'Facturé annuellement';
  WelcomeTour = 'Visite guidée';
  VideoTutorial = 'Tutoriel vidéo';
  Previous = 'Précédent';
  Next = 'Suivant';
  Page = 'Page';
  SavePatternReminder = 'N\'oubliez pas d\'enregistrer votre motif!';
  EarlyWarningBannerTitle = 'Vous avez enregistré 2 des 3 motifs gratuits!';
  EarlyWarningBannerText = 'Mettez à niveau maintenant pour des motifs illimités et des fonctionnalités premium.';
  ViewPlans = 'Voir les plans';
  PatternsUsed = 'sur 3 motifs utilisés';
  PatternsRemaining = 'restants';
  JoinThousandsCreators = 'Rejoignez des milliers de créateurs dans le monde';
  TrialInfoBanner = 'Essayez Pro gratuitement pendant 7 jours. Annulez à tout moment pendant l\'essai. Carte requise.';
  SevenDayFreeTrial = 'Essai gratuit de 7 jours';
  TrialPlusTwoMonthsFree = 'ESSAI GRATUIT DE 7 JOURS + 2 MOIS GRATUITS';
  TwoMonthsFree = 'OBTENEZ 2 MOIS GRATUITS';
  ThenMonthlyAfterTrial = 'Puis 5€/mois après l\'essai';
  ThenYearlyAfterTrial = 'Puis seulement 4,17€/mois après l\'essai';
  OnlyPricePerMonth = 'Seulement 4,17€/mois';
  MostPopular = 'Le Plus Populaire';
  SaveAmount = 'Économisez 10€/an';
  UnlimitedPatterns = 'Motifs illimités';
  HDExport = 'Export HD (300 DPI)';
  PDFSavePrint = 'Enregistrement et impression PDF';
  PrioritySupport = 'Support prioritaire';
  PatternReaderPaidFeature = 'Pattern Reader (gagne du temps + papier/encre)';
  PrintPDF = 'Impression / PDF';
  StandardQuality = 'Qualité standard';
  NoPDFExport = 'Pas d\'export PDF';
  EmailSupportOnly = 'Support email uniquement';
  OnlyThreePatterns = 'Seulement 3 motifs';
  StartFreeTrial = 'Démarrer l\'essai gratuit';
  StartMonthlyPlan = 'Démarrer le plan mensuel';
  StartYearlyPlan = 'Démarrer le plan annuel';
  CurrentPlan = 'Plan actuel';
  ContinueFree = 'Continuer gratuitement';
  MoneyBackGuarantee = 'Garantie de remboursement 30 jours';
  SecureCheckout = 'Paiement sécurisé';
  CancelAnytime = 'Annulez à tout moment';
  YourFreePlan = 'Votre plan gratuit';
  FreePlanStatus = 'Plan Gratuit';
  PatternsCreated = 'motifs';
  NoPDFPrinting = 'Pas de PDF/Impression';
  CreateBeautifulPatterns = 'Créez de magnifiques motifs de perles en quelques minutes';
  JoinThousandsCrafters = 'Rejoignez des milliers d\'artistes et d\'artisans de perles dans le monde';
  AutoSaveDesigns = 'Enregistrement automatique de vos créations dans le cloud';
  PrintProfessionalGuides = 'Imprimez des guides de motifs professionnels';
  AccessAnyDevice = 'Accédez depuis n\'importe quel appareil';
  StartThreeFreePatterns = 'Commencez avec 3 motifs gratuits';
  Initializing = 'Initialisation...';
  SignInWithGoogle = 'Se connecter avec Google';
  SecureAndPrivate = 'Sécurisé et privé';
  NoCreditCardRequired = 'Aucune carte de crédit requise';
  GetStarted = 'Commencer';
  AwesomeAllSet = 'Génial! Vous êtes prêt!';
  YourPlan = 'Votre plan';
  FreeTrial = 'Essai gratuit';
  DaysLeft = 'jours restants';
  TrialEndsIn = 'L\'essai se termine dans';
  Day = 'jour';
  Days = 'jours';
  AllProFeaturesIncluded = 'Toutes les fonctionnalités Pro incluses';
  UnlimitedPatternsHDExport = 'Motifs illimités et export HD';
  ContinueWithPro = 'Continuer avec Pro - À partir de 5€/mois';
  KeepProBenefits = 'Conservez tous les avantages Pro après la fin de l\'essai';
  FreePlan = 'Plan gratuit';
  Active = 'Actif';
  PatternUsage = 'Utilisation des motifs';
  PatternRemaining = 'motif restant';
  LimitReached = 'Limite atteinte - Mettez à niveau pour continuer';
  FreePlanLimited = 'Plan gratuit limité à 3 motifs';
  UpgradeToPro = 'Passer à Pro (5€/mois)';
  ProPlan = 'Plan Pro';
  UnlimitedPatternsFeature = 'Motifs illimités';
  HDExportPrint = 'Export HD et impression';
  ManageSubscription = 'Gérer l\'abonnement';
  ManageSubscriptionHint = 'Mettre à jour le paiement, changer de plan ou annuler';
  ProfileSettings = 'Paramètres du profil';
  UsedAllFreePatterns = 'Vous avez utilisé les 3 motifs gratuits. Mettez à niveau maintenant pour continuer à créer!';
  OnePatternRemaining = 'Il ne reste qu\'1 motif gratuit. Passez à l\'illimité!';
  Language = 'Langue';
  NeedHelpCta = 'Besoin d’aide ?';
  HelpPanelTitle = 'Besoin d’aide ?';
  HelpPanelSubtitle = 'Obtenez de l\'aide sans quitter l\'application.';
  HelpFaqHeading = 'Réponses rapides';
  HelpContactHeading = 'Contacter le support';
  HelpContactDescription = 'Si vous rencontrez un bug ou êtes bloqué, écrivez-nous et nous répondrons rapidement.';
  HelpContactEmailCta = 'Envoyer un email à support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini tutoriel';
  HelpTutorialDescription = 'Regardez une vidéo de 2 minutes sur les principaux outils.';
  HelpClose = 'Fermer l’aide';
  HelpFaqUploadQuestion = 'Comment importer ma photo d\'inspiration ?';
  HelpFaqUploadAnswer = 'Cliquez sur Image → Insérer une image dans la barre d\'outils. Vous pouvez importer n\'importe quelle photo et la convertir en motif de perles.';
  HelpFaqSaveQuestion = 'Comment enregistrer mon motif ?';
  HelpFaqSaveAnswer = 'Cliquez sur le bouton Enregistrer dans la barre d\'outils. Vos motifs sont automatiquement sauvegardés dans votre compte et accessibles à tout moment depuis Fichier → Ouvrir un motif.';
  HelpFaqExportQuestion = 'Comment exporter ou imprimer le motif ?';
  HelpFaqExportAnswer = 'Cliquez sur le bouton Imprimer dans la barre d\'outils pour générer des PDF haute résolution avec graphiques de perles, légendes de couleurs et listes de courses.';
  HelpFaqTutorialQuestion = 'Où apprendre rapidement les principaux outils ?';
  HelpFaqTutorialAnswer = 'Appuyez sur le bouton Vidéo tutoriel ci-dessous pour un tour de deux minutes sur l\'import, la conversion et l\'enregistrement.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Ajustez les paramètres ci-dessus, puis tapez Appliquer';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Tapez Image → Insérer une image';
  OnboardingHintTransferImage = 'Tapez Image → Transférer l\'image';
  OnboardingHintSave = 'Tapez Fichier → Enregistrer';

  // Welcome modal
  WelcomeModalTitle = 'Bienvenue sur Bead Pattern Maker !';
  WelcomeModalSubtitle = 'Créons votre premier motif de perles à partir d\'une image';
  WelcomeStep1Title = 'Importer Votre Image';
  WelcomeStep1Description = 'Choisissez une photo à convertir';
  WelcomeStep2Title = 'Positionner et Convertir';
  WelcomeStep2Description = 'Ajustez l\'image et convertissez-la en perles';
  WelcomeStep3Title = 'Enregistrer Votre Motif';
  WelcomeStep3Description = 'Conservez votre création pour plus tard';
  WelcomeGuidanceNote = 'Nous vous guiderons à chaque étape avec des conseils utiles';
  WelcomeShowMeHow = 'Montrez-moi';
  WelcomeWatchDemo = 'Voir Démo Rapide';
  WelcomeExploreOwn = 'J\'explore par moi-même';

  // Onboarding checklist
  ChecklistGetStarted = 'Commencer';
  ChecklistMinimize = 'Réduire';
  ChecklistCloseAndSkip = 'Fermer et ignorer le tutoriel';
  ChecklistAwesomeAllSet = '🎉 Génial ! Vous êtes prêt !';
  ChecklistTapToOpen = 'Appuyez pour ouvrir le menu';
  ChecklistMenuOpened = 'Appuyez sur l\'élément en surbrillance';
  ChecklistStepSignedIn = 'Connecté';
  ChecklistStepUploadImage = 'Importer une image';
  ChecklistStepConvertPattern = 'Convertir en motif';
  ChecklistStepSaveWork = 'Enregistrer votre travail';

  // Login page
  LoginPageTagline = 'Créez de magnifiques motifs de perles en quelques minutes';
  LoginPageSubtitle = 'Rejoignez des milliers d\'artistes et d\'artisans de perles dans le monde entier';
  LoginFeatureAutoSave = 'Sauvegardez automatiquement vos créations dans le cloud';
  LoginFeaturePrint = 'Imprimez des guides de motifs professionnels';
  LoginFeatureDevices = 'Accédez depuis n\'importe quel appareil';
  LoginFeatureUnlimited = 'Créez des motifs illimités';
  LoginInitializing = 'Initialisation...';
  LoginSignInGoogle = 'Se connecter avec Google';
  LoginGoogleLogoAlt = 'Logo Google';
  LoginSecurePrivate = 'Sécurisé et Privé';
  LoginStartFreePatterns = 'Commencez avec 3 motifs gratuits';
  LoginOneClick = 'Connexion en un clic — pas de mot de passe';
  LoginInProgress = 'Connexion en cours...';
  LoginCancelled = 'Connexion annulée. Veuillez réessayer.';
  LoginNetworkError = 'Impossible de se connecter à Google. Vérifiez votre connexion internet.';
  LoginAuthError = 'Échec de l\'authentification. Veuillez réessayer.';
  LoginGenericError = 'Une erreur s\'est produite. Veuillez réessayer.';
  TryAgain = 'Réessayer';

  // New pattern setup modal
  NewPatternTitle = 'Planifiez Votre Motif';
  NewPatternIntro = 'Choisissez un préréglage ou personnalisez le point et la taille de la grille pour votre motif.';
  NewPatternQuickPreset = 'Préréglage Rapide (Optionnel)';
  NewPatternCustomSize = 'Taille Personnalisée';
  NewPatternPopularProjects = 'Projets Populaires';
  NewPatternStitch = 'Point';
  NewPatternColumns = 'Colonnes';
  NewPatternRows = 'Rangées';
  NewPatternApproximateSize = 'Taille approximative :';
  NewPatternDimensionsNote = 'Dimensions basées sur les perles Miyuki Delica 11/0 (~1,8-2,1 mm). Les mesures sont approximatives.';
  NewPatternCancel = 'Annuler';
  NewPatternStart = 'Commencer';
  PresetClassicPeyoteBracelet = 'Bracelet Peyote Classique';
  PresetLoomBookmark = 'Marque-page Métier à Tisser';
  PresetBrickEarringsPair = 'Paire de Boucles d\'Oreilles Brick';
  PresetWidePeyoteCuff = 'Manchette Peyote Large';
  PresetSmallLoomPanel = 'Petit Panneau Métier à Tisser';
  PresetBrickPendant = 'Pendentif Brick';

  // Position image guide modal
  PositionImageTitle = 'Positionnez Votre Image';
  PositionImageCloseTooltip = 'Fermer';
  PositionImageHeading = 'Comment Positionner Votre Image';
  PositionImageDragTitle = 'Glisser pour Déplacer :';
  PositionImageDragDesc = 'Cliquez et faites glisser l\'image pour la positionner sur la grille de perles';
  PositionImageResizeTitle = 'Redimensionner :';
  PositionImageResizeDesc = 'Faites glisser les poignées des coins pour agrandir ou rétrécir votre image';
  PositionImageRotateTitle = 'Pivoter :';
  PositionImageRotateDesc = 'Utilisez les boutons de la barre d\'outils pour faire pivoter votre image si nécessaire';
  PositionImageTipLabel = 'Astuce :';
  PositionImageTipText = 'Positionnez votre image pour couvrir la zone que vous souhaitez convertir en perles';
  PositionImageReady = 'Lorsque vous êtes prêt, cliquez sur le bouton Transférer l\'Image (⚡) dans la barre d\'outils';
  PositionImageGotIt = 'Compris !';

  // Video player modal
  VideoPlayerCloseAria = 'Fermer la vidéo';
  VideoPlayerNotSupported = 'Votre navigateur ne prend pas en charge la balise vidéo.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Nous respectons votre vie privée';
  CookieConsentMessage = 'Nous utilisons des cookies et technologies similaires pour améliorer votre expérience, analyser l\'utilisation du site et soutenir nos efforts marketing. En cliquant sur "Accepter", vous consentez à l\'utilisation de cookies pour les analyses et l\'enregistrement des sessions afin d\'améliorer notre service.';
  CookieConsentDetails = 'Nous utilisons PostHog pour des analyses respectueuses de la vie privée. Aucune donnée n\'est vendue à des tiers. Vous pouvez retirer votre consentement à tout moment dans vos paramètres de profil.';
  CookieConsentAccept = 'Accepter';
  CookieConsentDecline = 'Refuser';

  PaletteMismatchError = 'Impossible de mélanger des perles de types différents. Ce motif utilise {0}.';

  NewPatternBeadType = 'Type de Perle';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Dimensions basées sur les perles Miyuki Delica 11/0 (~1,6×1,35 mm). Les mesures sont approximatives.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Dimensions basées sur les perles Preciosa Rocailles 11/0 (~2,1 mm). Les mesures sont approximatives.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

export class TranslationSpanish implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Creador de Patrones de Cuentas es una herramienta gratuita para crear patrones de cuentas de forma fácil e intuitiva. Es una herramienta web simple y potente para dar vida a tu imaginación.";
  File = 'Archivo';
  Edit = 'Editar';
  View = 'Ver';
  Image = 'Imagen';
  Help = 'Ayuda';
  About = 'Acerca de';
  Warning = 'Advertencia';
  ConfirmUnsavedPattern = 'El patrón actual no está guardado. ¿Está seguro de que desea continuar?';
  Tools = 'Herramientas';
  Name = 'Nombre';
  Description = 'Descripción';
  Category = 'Categoría';
  AddCategory = 'Añadir categoría';
  EditCategory = 'Editar categoría';
  DeleteCategory = 'Eliminar categoría';
  Ok = 'Ok';
  Cancel = 'Cancelar';
  ConfirmDelete = '¿Está seguro de que desea eliminar {0}?';
  AddPattern = 'Añadir patrón';
  EditPattern = 'Editar patrón';
  PaletteEditor = 'Editor de paletas';
  SelectPaletteToEdit = 'Seleccionar paleta para editar';
  NewPalette = 'Nueva paleta';
  DeletePalette = 'Eliminar paleta';
  MyPalette = 'Mi paleta';
  SelectACategory = 'Categoría';
  SearchPattern = 'Patrón';
  DeletePattern = 'Eliminar patrón';
  OpenPattern = 'Abrir patrón...';
  SavePattern = 'Guardar patrón...';
  PrintPattern = 'Imprimir patrón';
  BeadsPalette = 'Paleta de cuentas';
  BeadNumber = 'Cuenta n.º';
  Count = 'Cantidad';
  Print = 'Imprimir...';
  ExportPDF = 'Exportar PDF';
  Close = 'Cerrar';
  WordChart = 'Gráfico de palabras';
  ReplaceBeadWith = 'Reemplazar cuenta con...';
  Apply = 'Aplicar';
  TransferImage = 'Transferir imagen...';
  SelectPalette = 'Seleccionar paleta...';
  Colors = 'Colores';
  PaletteNameEdit = 'Nombre de paleta (Editar)';
  OnlyFirstNBeadPalettes = 'Solo las primeras {0} paletas de cuentas';
  Filter = 'Filtrar...';
  Add = 'Añadir';
  Remove = 'Eliminar';
  New = 'Nuevo';
  Open = 'Abrir';
  Save = 'Guardar';
  SaveAs = 'Guardar como...';
  Undo = 'Deshacer';
  Redo = 'Rehacer';
  ZoomIn = 'Acercar';
  ZoomOut = 'Alejar';
  InsertImage = 'Insertar imagen';
  InsertImageTooltip = 'Elegir foto (Tome primero una foto con la aplicación de cámara, luego selecciónela de la galería)';
  ShiftPatternLeft = 'Desplazar patrón a la izquierda';
  ShiftPatternRight = 'Desplazar patrón a la derecha';
  ShiftPatternUp = 'Desplazar patrón hacia arriba';
  ShiftPatternDown = 'Desplazar patrón hacia abajo';
  RotatePatternLeft = 'Rotar patrón a la izquierda';
  RotatePatternRight = 'Rotar patrón a la derecha';
  FlipPatternVertically = 'Voltear patrón verticalmente';
  FlipPatternHorizontally = 'Voltear patrón horizontalmente';
  All = 'Todos';
  AllPatterns = 'Todos los patrones';
  ShowHideImage = 'Mostrar/Ocultar imagen';
  RotateImageLeft = 'Rotar imagen a la izquierda';
  RotateImageRight = 'Rotar imagen a la derecha';
  RotateRight = 'Rotar a la derecha';
  RotateLeft = 'Rotar a la izquierda';
  PreEffect = 'Pre efecto';
  Method = 'Método';
  Dither = 'Difuminado';
  ShowSidebar = 'Mostrar barra lateral';
  HideSidebar = 'Ocultar barra lateral';
  TransformPattern = 'Transformar patrón';
  AddBead = 'Añadir cuenta';
  Fill = 'Rellenar';
  RemoveBead = 'Eliminar cuenta';
  RemoveFill = 'Eliminar relleno';
  PickBead = 'Seleccionar cuenta';
  Pan = 'Desplazar';
  Profile = 'Perfil';
  UnitOfMeasure = 'Unidad de medida';
  Inch = 'pulgada';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Filas';
  Columns = 'Columnas';
  Stitch = 'Puntada';
  Pattern = 'Patrón';
  Palettes = 'Paletas';
  Login = 'Iniciar sesión';
  NotSignedIn = 'Sin sesión iniciada';
  SignInWith = 'Iniciar sesión con';
  LoginWithFacebook = 'Iniciar sesión con Facebook';
  LoginWithGoogle = 'Iniciar sesión con Google';
  RotatedPatternOn = 'Patrón rotado (Activado)';
  RotatedPatternOff = 'Patrón rotado (Desactivado)';
  SignOut = 'Cerrar sesión';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'ELEGIR';
  ChoosePlan = 'Elegir plan';
  ChangePlan = 'Cambiar plan';
  ChangePlanDone = 'Plan cambiado. Puede tardar unos minutos en ver los cambios aplicados.';
  Subscription = 'Suscripción';
  FREE = 'GRATIS';
  MONTHLY = 'MENSUAL';
  YEARLY = 'ANUAL';
  SAVE20 = 'AHORRA 20%';
  NoCharge = 'Sin cargo';
  PlanFreeDescription1 = 'Guarda hasta 3 patrones';
  PlanFreeDescription2 = 'Sin impresión / PDF';
  PlanPaidDescription1 = 'Patrones ilimitados';
  PlanPaidDescription2 = 'Impresión / PDF';
  BilledMonthly = 'Facturado mensualmente';
  BilledAnnually = 'Facturado anualmente';
  WelcomeTour = 'Tour de bienvenida';
  VideoTutorial = 'Video tutorial';
  Previous = 'Anterior';
  Next = 'Siguiente';
  Page = 'Página';
  SavePatternReminder = '¡No olvides guardar tu patrón!';
  EarlyWarningBannerTitle = '¡Has guardado 2 de 3 patrones gratis!';
  EarlyWarningBannerText = 'Actualiza ahora para patrones ilimitados y funciones premium.';
  ViewPlans = 'Ver planes';
  PatternsUsed = 'de 3 patrones usados';
  PatternsRemaining = 'restantes';
  JoinThousandsCreators = 'Únete a miles de creadores en todo el mundo';
  TrialInfoBanner = 'Prueba Pro gratis durante 7 días. Cancela en cualquier momento durante la prueba. Tarjeta requerida.';
  SevenDayFreeTrial = 'Prueba gratis de 7 días';
  TrialPlusTwoMonthsFree = 'PRUEBA GRATIS DE 7 DÍAS + 2 MESES GRATIS';
  TwoMonthsFree = 'OBTÉN 2 MESES GRATIS';
  ThenMonthlyAfterTrial = 'Luego 5€/mes después de la prueba';
  ThenYearlyAfterTrial = 'Luego solo 4,17€/mes después de la prueba';
  OnlyPricePerMonth = 'Solo 4,17€/mes';
  MostPopular = 'Más Popular';
  SaveAmount = 'Ahorra 10€/año';
  UnlimitedPatterns = 'Patrones ilimitados';
  HDExport = 'Exportación HD (300 DPI)';
  PDFSavePrint = 'Guardar e imprimir PDF';
  PrioritySupport = 'Soporte prioritario';
  PatternReaderPaidFeature = 'Pattern Reader (ahorra tiempo + papel/tinta)';
  PrintPDF = 'Imprimir / PDF';
  StandardQuality = 'Calidad estándar';
  NoPDFExport = 'Sin exportación PDF';
  EmailSupportOnly = 'Solo soporte por email';
  OnlyThreePatterns = 'Solo 3 patrones';
  StartFreeTrial = 'Iniciar prueba gratis';
  StartMonthlyPlan = 'Iniciar plan mensual';
  StartYearlyPlan = 'Iniciar plan anual';
  CurrentPlan = 'Plan actual';
  ContinueFree = 'Continuar gratis';
  MoneyBackGuarantee = 'Garantía de devolución de 30 días';
  SecureCheckout = 'Pago seguro';
  CancelAnytime = 'Cancela en cualquier momento';
  YourFreePlan = 'Tu plan gratuito';
  FreePlanStatus = 'Plan Gratuito';
  PatternsCreated = 'patrones';
  NoPDFPrinting = 'Sin PDF/Impresión';
  CreateBeautifulPatterns = 'Crea hermosos patrones de cuentas en minutos';
  JoinThousandsCrafters = 'Únete a miles de artistas y artesanos de cuentas en todo el mundo';
  AutoSaveDesigns = 'Guarda automáticamente tus diseños en la nube';
  PrintProfessionalGuides = 'Imprime guías de patrones profesionales';
  AccessAnyDevice = 'Accede desde cualquier dispositivo';
  StartThreeFreePatterns = 'Comienza con 3 patrones gratis';
  Initializing = 'Inicializando...';
  SignInWithGoogle = 'Iniciar sesión con Google';
  SecureAndPrivate = 'Seguro y privado';
  NoCreditCardRequired = 'No se requiere tarjeta de crédito';
  GetStarted = 'Comenzar';
  AwesomeAllSet = '¡Genial! ¡Estás listo!';
  YourPlan = 'Tu plan';
  FreeTrial = 'Prueba gratuita';
  DaysLeft = 'días restantes';
  TrialEndsIn = 'La prueba termina en';
  Day = 'día';
  Days = 'días';
  AllProFeaturesIncluded = 'Todas las funciones Pro incluidas';
  UnlimitedPatternsHDExport = 'Patrones ilimitados y exportación HD';
  ContinueWithPro = 'Continuar con Pro - Desde 5€/mes';
  KeepProBenefits = 'Mantén todos los beneficios Pro después del fin de la prueba';
  FreePlan = 'Plan gratuito';
  Active = 'Activo';
  PatternUsage = 'Uso de patrones';
  PatternRemaining = 'patrón restante';
  LimitReached = 'Límite alcanzado - Actualiza para continuar';
  FreePlanLimited = 'Plan gratuito limitado a 3 patrones';
  UpgradeToPro = 'Actualizar a Pro (5€/mes)';
  ProPlan = 'Plan Pro';
  UnlimitedPatternsFeature = 'Patrones ilimitados';
  HDExportPrint = 'Exportación HD e impresión';
  ManageSubscription = 'Administrar suscripción';
  ManageSubscriptionHint = 'Actualizar pago, cambiar plan o cancelar';
  ProfileSettings = 'Configuración de perfil';
  UsedAllFreePatterns = '¡Has usado los 3 patrones gratis. Actualiza ahora para seguir creando!';
  OnePatternRemaining = 'Solo queda 1 patrón gratis. ¡Actualiza para patrones ilimitados!';
  Language = 'Idioma';
  NeedHelpCta = '¿Necesitas ayuda?';
  HelpPanelTitle = '¿Necesitas ayuda?';
  HelpPanelSubtitle = 'Obtén ayuda sin salir de la aplicación.';
  HelpFaqHeading = 'Respuestas rápidas';
  HelpContactHeading = 'Contactar soporte';
  HelpContactDescription = 'Si encuentras un error o te quedas atascado, escríbenos y te responderemos pronto.';
  HelpContactEmailCta = 'Enviar correo a support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini tutorial';
  HelpTutorialDescription = 'Mira un video de 2 minutos sobre las herramientas principales.';
  HelpClose = 'Cerrar ayuda';
  HelpFaqUploadQuestion = '¿Cómo subo mi foto de inspiración?';
  HelpFaqUploadAnswer = 'Haz clic en Imagen → Insertar imagen en la barra de herramientas. Puedes subir cualquier foto y convertirla en un patrón de cuentas.';
  HelpFaqSaveQuestion = '¿Cómo guardo mi patrón?';
  HelpFaqSaveAnswer = 'Haz clic en el botón Guardar de la barra de herramientas. Tus patrones se guardan automáticamente en tu cuenta y puedes acceder a ellos en cualquier momento desde Archivo → Abrir patrón.';
  HelpFaqExportQuestion = '¿Cómo puedo exportar o imprimir el patrón?';
  HelpFaqExportAnswer = 'Haz clic en el botón Imprimir de la barra de herramientas para generar PDF de alta resolución con gráficos de cuentas, leyendas de colores y listas de compra.';
  HelpFaqTutorialQuestion = '¿Dónde puedo aprender rápido las herramientas principales?';
  HelpFaqTutorialAnswer = 'Pulsa el botón Video Tutorial para ver un recorrido de dos minutos sobre subir, convertir y guardar.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Ajusta la configuración arriba, luego toca Aplicar';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Toca Imagen → Insertar imagen';
  OnboardingHintTransferImage = 'Toca Imagen → Transferir imagen';
  OnboardingHintSave = 'Toca Archivo → Guardar';

  // Welcome modal
  WelcomeModalTitle = '¡Bienvenido a Bead Pattern Maker!';
  WelcomeModalSubtitle = 'Creemos tu primer patrón de cuentas desde una imagen';
  WelcomeStep1Title = 'Sube Tu Imagen';
  WelcomeStep1Description = 'Elige una foto para convertir';
  WelcomeStep2Title = 'Posiciona y Convierte';
  WelcomeStep2Description = 'Ajusta la imagen y conviértela en cuentas';
  WelcomeStep3Title = 'Guarda Tu Patrón';
  WelcomeStep3Description = 'Conserva tu creación para el futuro';
  WelcomeGuidanceNote = 'Te guiaremos en cada paso con consejos útiles';
  WelcomeShowMeHow = 'Muéstrame Cómo';
  WelcomeWatchDemo = 'Ver Demo Rápida';
  WelcomeExploreOwn = 'Exploraré por Mi Cuenta';

  // Onboarding checklist
  ChecklistGetStarted = 'Comenzar';
  ChecklistMinimize = 'Minimizar';
  ChecklistCloseAndSkip = 'Cerrar y omitir tutorial';
  ChecklistAwesomeAllSet = '🎉 ¡Genial! ¡Estás listo!';
  ChecklistTapToOpen = 'Toca para abrir el menú';
  ChecklistMenuOpened = 'Toca el elemento resaltado';
  ChecklistStepSignedIn = 'Sesión iniciada';
  ChecklistStepUploadImage = 'Subir una imagen';
  ChecklistStepConvertPattern = 'Convertir a patrón';
  ChecklistStepSaveWork = 'Guardar tu trabajo';

  // Login page
  LoginPageTagline = 'Crea hermosos patrones de cuentas en minutos';
  LoginPageSubtitle = 'Únete a miles de artistas y artesanos de cuentas en todo el mundo';
  LoginFeatureAutoSave = 'Guarda automáticamente tus diseños en la nube';
  LoginFeaturePrint = 'Imprime guías de patrones profesionales';
  LoginFeatureDevices = 'Accede desde cualquier dispositivo';
  LoginFeatureUnlimited = 'Crea patrones ilimitados';
  LoginInitializing = 'Inicializando...';
  LoginSignInGoogle = 'Iniciar sesión con Google';
  LoginGoogleLogoAlt = 'Logo de Google';
  LoginSecurePrivate = 'Seguro y Privado';
  LoginStartFreePatterns = 'Comienza con 3 patrones gratuitos';
  LoginOneClick = 'Inicio de sesión con un clic — sin contraseñas';
  LoginInProgress = 'Iniciando sesión...';
  LoginCancelled = 'Inicio de sesión cancelado. Por favor, inténtalo de nuevo.';
  LoginNetworkError = 'No se puede conectar con Google. Comprueba tu conexión a internet.';
  LoginAuthError = 'Error de autenticación. Por favor, inténtalo de nuevo.';
  LoginGenericError = 'Algo salió mal. Por favor, inténtalo de nuevo.';
  TryAgain = 'Intentar de nuevo';

  // New pattern setup modal
  NewPatternTitle = 'Planifica Tu Patrón';
  NewPatternIntro = 'Elige un preset o personaliza el punto y el tamaño de la cuadrícula para tu patrón.';
  NewPatternQuickPreset = 'Preset Rápido (Opcional)';
  NewPatternCustomSize = 'Tamaño Personalizado';
  NewPatternPopularProjects = 'Proyectos Populares';
  NewPatternStitch = 'Punto';
  NewPatternColumns = 'Columnas';
  NewPatternRows = 'Filas';
  NewPatternApproximateSize = 'Tamaño aproximado:';
  NewPatternDimensionsNote = 'Dimensiones basadas en cuentas Miyuki Delica 11/0 (~1,8-2,1 mm). Las medidas son aproximadas.';
  NewPatternCancel = 'Cancelar';
  NewPatternStart = 'Comenzar';
  PresetClassicPeyoteBracelet = 'Pulsera Peyote Clásica';
  PresetLoomBookmark = 'Marcapáginas Telar';
  PresetBrickEarringsPair = 'Par de Pendientes Brick';
  PresetWidePeyoteCuff = 'Brazalete Peyote Ancho';
  PresetSmallLoomPanel = 'Panel Telar Pequeño';
  PresetBrickPendant = 'Colgante Brick';

  // Position image guide modal
  PositionImageTitle = 'Posiciona Tu Imagen';
  PositionImageCloseTooltip = 'Cerrar';
  PositionImageHeading = 'Cómo Posicionar Tu Imagen';
  PositionImageDragTitle = 'Arrastra para Mover:';
  PositionImageDragDesc = 'Haz clic y arrastra la imagen para posicionarla sobre la cuadrícula de cuentas';
  PositionImageResizeTitle = 'Redimensionar:';
  PositionImageResizeDesc = 'Arrastra las esquinas para hacer tu imagen más grande o más pequeña';
  PositionImageRotateTitle = 'Rotar:';
  PositionImageRotateDesc = 'Usa los botones de la barra de herramientas para rotar tu imagen si es necesario';
  PositionImageTipLabel = 'Consejo:';
  PositionImageTipText = 'Posiciona tu imagen para cubrir el área que quieres convertir en cuentas';
  PositionImageReady = 'Cuando estés listo, haz clic en el botón Transferir Imagen (⚡) en la barra de herramientas';
  PositionImageGotIt = '¡Entendido!';

  // Video player modal
  VideoPlayerCloseAria = 'Cerrar video';
  VideoPlayerNotSupported = 'Tu navegador no soporta la etiqueta de video.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Valoramos tu privacidad';
  CookieConsentMessage = 'Utilizamos cookies y tecnologías similares para mejorar tu experiencia, analizar el uso del sitio y apoyar nuestros esfuerzos de marketing. Al hacer clic en "Aceptar", consientes el uso de cookies para análisis y grabación de sesiones para ayudarnos a mejorar nuestro servicio.';
  CookieConsentDetails = 'Utilizamos PostHog para análisis centrados en la privacidad. No se venden datos a terceros. Puedes retirar el consentimiento en cualquier momento en la configuración de tu perfil.';
  CookieConsentAccept = 'Aceptar';
  CookieConsentDecline = 'Rechazar';

  PaletteMismatchError = 'No se pueden mezclar abalorios de diferentes tipos. Este patrón utiliza {0}.';

  NewPatternBeadType = 'Tipo de Abalorio';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Dimensiones basadas en cuentas Miyuki Delica 11/0 (~1,6×1,35 mm). Las medidas son aproximadas.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Dimensiones basadas en cuentas Preciosa Rocailles 11/0 (~2,1 mm). Las medidas son aproximadas.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

export class TranslationDutch implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Kralenpatroon Maker is een gratis tool om kralenpatronen te maken van je afbeeldingen. Upload een afbeelding, kies je kleurenpalet en converteer het naar een kralenpatroon. Je kunt het patroon bewerken, de kleuren aanpassen en het exporteren als PDF. De app ondersteunt meerdere kralenpaletten zoals Perler, Hama, Artkal en meer.";
  File = 'Bestand';
  Edit = 'Bewerken';
  View = 'Weergave';
  Image = 'Afbeelding';
  Help = 'Help';
  About = 'Over';
  Warning = 'Waarschuwing';
  ConfirmUnsavedPattern = 'Het huidige patroon is niet opgeslagen. Weet je zeker dat je wilt doorgaan?';
  Tools = 'Hulpmiddelen';
  Name = 'Naam';
  Description = 'Omschrijving';
  Category = 'Categorie';
  AddCategory = 'Categorie toevoegen';
  EditCategory = 'Categorie bewerken';
  DeleteCategory = 'Categorie verwijderen';
  Ok = 'OK';
  Cancel = 'Annuleren';
  ConfirmDelete = 'Weet je zeker dat je {0} wilt verwijderen?';
  AddPattern = 'Patroon toevoegen';
  EditPattern = 'Patroon bewerken';
  PaletteEditor = 'Palet Editor';
  SelectPaletteToEdit = 'Selecteer palet om te bewerken';
  NewPalette = 'Nieuw Palet';
  DeletePalette = 'Palet verwijderen';
  MyPalette = 'Mijn Palet';
  SelectACategory = 'Categorie';
  SearchPattern = 'Patroon';
  DeletePattern = 'Patroon verwijderen';
  OpenPattern = 'Patroon openen...';
  SavePattern = 'Patroon opslaan...';
  PrintPattern = 'Patroon afdrukken';
  BeadsPalette = 'Kralen Palet';
  BeadNumber = 'Kraal #';
  Count = 'Aantal';
  Print = 'Afdrukken...';
  ExportPDF = 'Exporteer PDF';
  Close = 'Sluiten';
  WordChart = 'Woord Grafiek';
  ReplaceBeadWith = 'Vervang Kraal met...';
  Apply = 'Toepassen';
  TransferImage = 'Afbeelding overbrengen...';
  SelectPalette = 'Selecteer palet...';
  Colors = 'Kleuren';
  PaletteNameEdit = 'Palet Naam (Bewerken)';
  OnlyFirstNBeadPalettes = 'Alleen eerste {0} kralenpaletten';
  Filter = 'Filteren...';
  Add = 'Toevoegen';
  Remove = 'Verwijderen';
  New = 'Nieuw';
  Open = 'Openen';
  Save = 'Opslaan';
  SaveAs = 'Opslaan als...';
  Undo = 'Ongedaan maken';
  Redo = 'Opnieuw doen';
  ZoomIn = 'Inzoomen';
  ZoomOut = 'Uitzoomen';
  InsertImage = 'Afbeelding invoegen';
  InsertImageTooltip = 'Foto kiezen (Maak eerst een foto met de camera-app en selecteer deze vervolgens uit de galerij)';
  ShiftPatternLeft = 'Patroon naar links verschuiven';
  ShiftPatternRight = 'Patroon naar rechts verschuiven';
  ShiftPatternUp = 'Patroon omhoog verschuiven';
  ShiftPatternDown = 'Patroon omlaag verschuiven';
  RotatePatternLeft = 'Patroon naar links roteren';
  RotatePatternRight = 'Patroon naar rechts roteren';
  FlipPatternVertically = 'Patroon verticaal spiegelen';
  FlipPatternHorizontally = 'Patroon horizontaal spiegelen';
  All = 'Alle';
  AllPatterns = 'Alle patronen';
  ShowHideImage = 'Afbeelding tonen/verbergen';
  RotateImageLeft = 'Afbeelding naar links roteren';
  RotateImageRight = 'Afbeelding naar rechts roteren';
  RotateRight = 'Rechts roteren';
  RotateLeft = 'Links roteren';
  PreEffect = 'Pre Effect';
  Method = 'Methode';
  Dither = 'Dither';
  ShowSidebar = 'Zijbalk tonen';
  HideSidebar = 'Zijbalk verbergen';
  TransformPattern = 'Patroon transformeren';
  AddBead = 'Kraal toevoegen';
  Fill = 'Vullen';
  RemoveBead = 'Kraal verwijderen';
  RemoveFill = 'Vulling verwijderen';
  PickBead = 'Kraal kiezen';
  Pan = 'Pannen';
  Profile = 'Profiel';
  UnitOfMeasure = 'Maateenheid';
  Inch = 'inch';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Rijen';
  Columns = 'Kolommen';
  Stitch = 'Steek';
  Pattern = 'Patroon';
  Palettes = 'Paletten';
  Login = 'Inloggen';
  NotSignedIn = 'Niet ingelogd';
  SignInWith = 'Inloggen met';
  LoginWithFacebook = 'Inloggen met Facebook';
  LoginWithGoogle = 'Inloggen met Google';
  RotatedPatternOn = 'Geroteerd Patroon (Aan)';
  RotatedPatternOff = 'Geroteerd Patroon (Uit)';
  SignOut = 'Uitloggen';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'KIEZEN';
  ChoosePlan = 'Kies abonnement';
  ChangePlan = 'Abonnement wijzigen';
  ChangePlanDone = 'Abonnement gewijzigd. Het kan enkele minuten duren voordat de wijzigingen worden toegepast.';
  Subscription = 'Abonnement';
  FREE = 'GRATIS';
  MONTHLY = 'MAANDELIJKS';
  YEARLY = 'JAARLIJKS';
  SAVE20 = 'BESPAAR 20%';
  NoCharge = 'Geen kosten';
  PlanFreeDescription1 = 'Bewaar tot 3 patronen';
  PlanFreeDescription2 = 'Geen Afdruk / PDF';
  PlanPaidDescription1 = 'Onbeperkte patronen';
  PlanPaidDescription2 = 'Afdruk / PDF';
  BilledMonthly = 'Maandelijks gefactureerd';
  BilledAnnually = 'Jaarlijks gefactureerd';
  WelcomeTour = 'Welkomst Tour';
  VideoTutorial = 'Video Tutorial';
  Previous = 'Vorige';
  Next = 'Volgende';
  Page = 'Pagina';
  SavePatternReminder = 'Vergeet niet je patroon op te slaan!';
  EarlyWarningBannerTitle = 'Je hebt 2 van de 3 gratis patronen opgeslagen!';
  EarlyWarningBannerText = 'Upgrade nu voor onbeperkte patronen en premium functies.';
  ViewPlans = 'Bekijk Abonnementen';
  PatternsUsed = '{0} van 3 patronen gebruikt';
  PatternsRemaining = '({0} resterend)';
  JoinThousandsCreators = 'Sluit je aan bij duizenden makers wereldwijd';
  TrialInfoBanner = 'Probeer Pro gratis 7 dagen. Annuleer op elk moment tijdens de proefperiode. Kaart vereist.';
  SevenDayFreeTrial = '7-Daagse Gratis Proefperiode';
  TrialPlusTwoMonthsFree = '7-DAGEN GRATIS PROEFPERIODE + 2 MAANDEN GRATIS';
  TwoMonthsFree = 'KRIJG 2 MAANDEN GRATIS';
  ThenMonthlyAfterTrial = 'Dan $5/maand na proefperiode';
  ThenYearlyAfterTrial = 'Dan slechts $4.17/maand na proefperiode';
  OnlyPricePerMonth = 'Slechts $4.17/maand';
  MostPopular = 'Meest Populair';
  SaveAmount = 'Bespaar $10/jaar';
  UnlimitedPatterns = 'Onbeperkte patronen';
  HDExport = 'HD export (300 DPI)';
  PDFSavePrint = 'PDF opslaan & afdrukken';
  PrioritySupport = 'Prioriteit ondersteuning';
  PatternReaderPaidFeature = 'Pattern Reader (bespaart tijd + papier/inkt)';
  PrintPDF = 'Afdruk / PDF';
  StandardQuality = 'Standaard kwaliteit';
  NoPDFExport = 'Geen PDF export';
  EmailSupportOnly = 'Alleen e-mail ondersteuning';
  OnlyThreePatterns = 'Slechts 3 patronen';
  StartFreeTrial = 'Start gratis proefperiode';
  StartMonthlyPlan = 'Start maandelijks abonnement';
  StartYearlyPlan = 'Start jaarlijks abonnement';
  CurrentPlan = 'Huidig abonnement';
  ContinueFree = 'Gratis voortzetten';
  MoneyBackGuarantee = '30-Dagen Geld Terug';
  SecureCheckout = 'Veilige checkout';
  CancelAnytime = 'Annuleer op elk moment';
  YourFreePlan = 'Je Gratis Abonnement';
  FreePlanStatus = 'Gratis Abonnement';
  PatternsCreated = 'patronen';
  NoPDFPrinting = 'Geen PDF/Print';
  CreateBeautifulPatterns = 'Maak prachtige kralenpatronen in minuten';
  JoinThousandsCrafters = 'Sluit je aan bij duizenden kralenkunstenaars en ambachtslieden wereldwijd';
  AutoSaveDesigns = 'Auto-sla je ontwerpen op in de cloud';
  PrintProfessionalGuides = 'Druk professionele patroongidsen af';
  AccessAnyDevice = 'Toegang vanaf elk apparaat';
  StartThreeFreePatterns = 'Begin met 3 gratis patronen';
  Initializing = 'Initialiseren...';
  SignInWithGoogle = 'Inloggen met Google';
  SecureAndPrivate = 'Veilig & Privé';
  NoCreditCardRequired = 'Geen creditcard vereist';
  GetStarted = 'Aan de slag';
  AwesomeAllSet = 'Geweldig! Je bent klaar!';
  YourPlan = 'Je Abonnement';
  FreeTrial = 'Gratis Proefperiode';
  DaysLeft = 'dagen over';
  TrialEndsIn = 'Proefperiode eindigt over';
  Day = 'dag';
  Days = 'dagen';
  AllProFeaturesIncluded = 'Alle Pro functies inbegrepen';
  UnlimitedPatternsHDExport = 'Onbeperkte patronen & HD export';
  ContinueWithPro = 'Ga door met Pro - Vanaf $5/maand';
  KeepProBenefits = 'Behoud alle Pro voordelen na proefperiode';
  FreePlan = 'Gratis Abonnement';
  Active = 'Actief';
  PatternUsage = 'Patroon Gebruik';
  PatternRemaining = '{0} patroon{1} resterend';
  LimitReached = 'Limiet bereikt - Upgrade om door te gaan';
  FreePlanLimited = 'Gratis abonnement beperkt tot 3 patronen';
  UpgradeToPro = 'Upgrade naar Pro ($5/maand)';
  ProPlan = 'Pro Abonnement';
  UnlimitedPatternsFeature = 'Onbeperkte patronen';
  HDExportPrint = 'HD export & Afdruk';
  ManageSubscription = 'Abonnement beheren';
  ManageSubscriptionHint = 'Betaalmethode bijwerken, abonnement wijzigen of annuleren';
  ProfileSettings = 'Profiel Instellingen';
  UsedAllFreePatterns = 'Je hebt alle 3 gratis patronen gebruikt. Upgrade nu om door te gaan met maken!';
  OnePatternRemaining = 'Nog slechts 1 gratis patroon over. Upgrade voor onbeperkte patronen!';
  Language = 'Taal';
  NeedHelpCta = 'Hulp nodig?';
  HelpPanelTitle = 'Hulp nodig?';
  HelpPanelSubtitle = 'Krijg hulp zonder de app te verlaten.';
  HelpFaqHeading = 'Snelle antwoorden';
  HelpContactHeading = 'Support contacteren';
  HelpContactDescription = 'Vind je een bug of zit je vast? Stuur ons een bericht en we reageren snel.';
  HelpContactEmailCta = 'Mail naar support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini-tutorial';
  HelpTutorialDescription = 'Bekijk een video van 2 minuten over de belangrijkste tools.';
  HelpClose = 'Hulp sluiten';
  HelpFaqUploadQuestion = 'Hoe upload ik mijn inspiratiefoto?';
  HelpFaqUploadAnswer = 'Klik op Afbeelding → Afbeelding invoegen in de toolbar. Je kunt elke foto uploaden en omzetten naar een kralenpatroon.';
  HelpFaqSaveQuestion = 'Hoe sla ik mijn patroon op?';
  HelpFaqSaveAnswer = 'Klik op de knop Opslaan in de toolbar. Je patronen worden automatisch opgeslagen in je account en zijn altijd toegankelijk via Bestand → Patroon openen.';
  HelpFaqExportQuestion = 'Hoe kan ik het patroon exporteren of afdrukken?';
  HelpFaqExportAnswer = 'Klik op de knop Afdrukken in de toolbar om PDF\'s met hoge resolutie te maken met kraaldiagrammen, kleurlegendes en boodschappenlijsten.';
  HelpFaqTutorialQuestion = 'Waar leer ik de belangrijkste tools snel?';
  HelpFaqTutorialAnswer = 'Klik op de knop Video Tutorial hieronder voor een rondleiding van twee minuten over uploaden, converteren en opslaan.';
  Trial7DayTitle = 'Start je 7-daagse gratis proefperiode';
  Trial7DaySubtitle = 'Ervaar onbeperkte mogelijkheden. Annuleer op elk moment. Geen creditcard vereist.';
  SubscriptionRequiredTitle = 'Abonnement vereist';
  SubscriptionRequiredMessage = 'Een actief abonnement is vereist om door te gaan.';
  UpgradeNow = 'Nu upgraden';
  TryFreeFor7Days = '7 dagen gratis proberen';
  HighResolutionExports = 'Exports in hoge resolutie';
  RemoveWatermarks = 'Watermerken verwijderen';
  AdvancedEditingTools = 'Geavanceerde bewerkingstools';
  MonthlySubscription = 'Maandelijks abonnement';
  YearlySubscription = 'Jaarlijks abonnement';
  PerMonth = '/maand';
  PerYear = '/jaar';
  BilledYearly = 'Jaarlijks gefactureerd';
  Save20Percent = 'Bespaar 20%';
  NoCommitment = 'Geen verplichtingen';
  SecurePayment = 'Veilige betaling';
  FreeTrialActive = 'Gratis proefperiode actief';
  TrialEndsOn = 'Proefperiode eindigt op';
  DaysRemaining = 'dagen resterend';
  PremiumPlan = 'Premium abonnement';
  CreateUnlimitedPatterns = 'Maak onbeperkte patronen';
  ExportHighQualityPDFs = 'Exporteer PDF\'s van hoge kwaliteit';
  AccessAllPalettes = 'Toegang tot alle paletten';
  GetPrioritySupport = 'Krijg prioriteit ondersteuning';
  NoAdsExperience = 'Advertentievrije ervaring';
  UnlockAllFeatures = 'Ontgrendel alle functies';
  UpgradeToUnlock = 'Upgrade om te ontgrendelen';
  SelectSubscription = 'Selecteer abonnement';
  ProceedToCheckout = 'Ga naar afrekenen';
  CreateYourFirstPattern = 'Maak je eerste patroon! Upload een afbeelding, kies een palet en laat de magie gebeuren.';
  TryDifferentPalettes = 'Probeer verschillende paletten! Wissel tussen Perler, Hama, Artkal en meer om de perfecte look te vinden.';
  Or = 'Of';
  ContinueAsGuest = 'Doorgaan als gast';
  CreateBeadPatterns = 'Maak prachtige kralenpatronen van je afbeeldingen';
  GetStartedFree = 'Gratis beginnen';
  FeatureFreeForever = 'Gratis voor altijd';
  FeatureNoWatermark = 'Geen watermerken';
  Feature3FreePatterns = '3 gratis patronen';
  FeatureAllPalettes = 'Alle paletten';
  HowItWorks = 'Hoe het werkt';
  Step1UploadImage = 'Upload een afbeelding';
  Step2ChoosePalette = 'Kies je palet';
  Step3ExportPattern = 'Exporteer je patroon';
  ReadyToStart = 'Klaar om te beginnen?';
  JoinNow = 'Nu lid worden';
  ProfileMenu = 'Profiel';
  MySubscription = 'Mijn abonnement';
  TwoPatternsRemaining = 'Nog 2 gratis patronen over. Upgrade voor onbeperkte patronen!';
  ViewSubscription = 'Bekijk abonnement';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Pas de instellingen hierboven aan, tik dan op Toepassen';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Tik Afbeelding → Afbeelding invoegen';
  OnboardingHintTransferImage = 'Tik Afbeelding → Afbeelding overbrengen';
  OnboardingHintSave = 'Tik Bestand → Opslaan';

  // Welcome modal
  WelcomeModalTitle = 'Welkom bij Bead Pattern Maker!';
  WelcomeModalSubtitle = 'Laten we je eerste kralenpatroon maken van een afbeelding';
  WelcomeStep1Title = 'Upload Je Afbeelding';
  WelcomeStep1Description = 'Kies een foto om te converteren';
  WelcomeStep2Title = 'Positioneer & Converteer';
  WelcomeStep2Description = 'Pas de afbeelding aan en converteer naar kralen';
  WelcomeStep3Title = 'Bewaar Je Patroon';
  WelcomeStep3Description = 'Bewaar je creatie voor later gebruik';
  WelcomeGuidanceNote = 'We begeleiden je bij elke stap met handige tips';
  WelcomeShowMeHow = 'Laat het me zien';
  WelcomeWatchDemo = 'Bekijk Korte Demo';
  WelcomeExploreOwn = 'Ik verken het zelf';

  // Onboarding checklist
  ChecklistGetStarted = 'Begin';
  ChecklistMinimize = 'Minimaliseren';
  ChecklistCloseAndSkip = 'Sluit en sla tutorial over';
  ChecklistAwesomeAllSet = '🎉 Geweldig! Je bent klaar!';
  ChecklistTapToOpen = 'Tik om het menu te openen';
  ChecklistMenuOpened = 'Tik op het gemarkeerde item';
  ChecklistStepSignedIn = 'Ingelogd';
  ChecklistStepUploadImage = 'Upload een afbeelding';
  ChecklistStepConvertPattern = 'Converteer naar patroon';
  ChecklistStepSaveWork = 'Bewaar je werk';

  // Login page
  LoginPageTagline = 'Maak in enkele minuten prachtige kralenpatronen';
  LoginPageSubtitle = 'Sluit je aan bij duizenden kralenkunstenaars en ambachtslieden wereldwijd';
  LoginFeatureAutoSave = 'Sla je ontwerpen automatisch op in de cloud';
  LoginFeaturePrint = 'Druk professionele patroonhandleidingen af';
  LoginFeatureDevices = 'Toegang vanaf elk apparaat';
  LoginFeatureUnlimited = 'Maak onbeperkt patronen';
  LoginInitializing = 'Initialiseren...';
  LoginSignInGoogle = 'Aanmelden met Google';
  LoginGoogleLogoAlt = 'Google-logo';
  LoginSecurePrivate = 'Veilig & Privé';
  LoginStartFreePatterns = 'Begin met 3 gratis patronen';
  LoginOneClick = 'Inloggen met één klik — geen wachtwoord nodig';
  LoginInProgress = 'Bezig met inloggen...';
  LoginCancelled = 'Inloggen geannuleerd. Probeer het opnieuw.';
  LoginNetworkError = 'Kan geen verbinding maken met Google. Controleer je internetverbinding.';
  LoginAuthError = 'Verificatie mislukt. Probeer het opnieuw.';
  LoginGenericError = 'Er ging iets mis. Probeer het opnieuw.';
  TryAgain = 'Opnieuw proberen';

  // New pattern setup modal
  NewPatternTitle = 'Plan Je Patroon';
  NewPatternIntro = 'Kies een preset of pas de steek en rastergrootte aan voor je patroon.';
  NewPatternQuickPreset = 'Snelle Preset (Optioneel)';
  NewPatternCustomSize = 'Aangepaste Grootte';
  NewPatternPopularProjects = 'Populaire Projecten';
  NewPatternStitch = 'Steek';
  NewPatternColumns = 'Kolommen';
  NewPatternRows = 'Rijen';
  NewPatternApproximateSize = 'Geschatte grootte:';
  NewPatternDimensionsNote = 'Afmetingen gebaseerd op Miyuki Delica 11/0 kralen (~1,8-2,1 mm). Metingen zijn bij benadering.';
  NewPatternCancel = 'Annuleren';
  NewPatternStart = 'Starten';
  PresetClassicPeyoteBracelet = 'Klassieke Peyote Armband';
  PresetLoomBookmark = 'Weefgetouw Bladwijzer';
  PresetBrickEarringsPair = 'Brick Oorbellen Paar';
  PresetWidePeyoteCuff = 'Brede Peyote Manchet';
  PresetSmallLoomPanel = 'Klein Weefgetouw Paneel';
  PresetBrickPendant = 'Brick Hanger';

  // Position image guide modal
  PositionImageTitle = 'Positioneer Je Afbeelding';
  PositionImageCloseTooltip = 'Sluiten';
  PositionImageHeading = 'Hoe Je Afbeelding te Positioneren';
  PositionImageDragTitle = 'Slepen om te Verplaatsen:';
  PositionImageDragDesc = 'Klik en sleep de afbeelding om het over het kralenraster te positioneren';
  PositionImageResizeTitle = 'Grootte Aanpassen:';
  PositionImageResizeDesc = 'Sleep de hoekgrepen om je afbeelding groter of kleiner te maken';
  PositionImageRotateTitle = 'Roteren:';
  PositionImageRotateDesc = 'Gebruik de werkbalkknoppen om je afbeelding indien nodig te draaien';
  PositionImageTipLabel = 'Tip:';
  PositionImageTipText = 'Positioneer je afbeelding om het gebied te bedekken dat je wilt omzetten in kralen';
  PositionImageReady = 'Als je klaar bent, klik op de knop Afbeelding Overdragen (⚡) in de werkbalk';
  PositionImageGotIt = 'Begrepen!';

  // Video player modal
  VideoPlayerCloseAria = 'Video sluiten';
  VideoPlayerNotSupported = 'Uw browser ondersteunt de videotag niet.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Wij waarderen uw privacy';
  CookieConsentMessage = 'Wij gebruiken cookies en soortgelijke technologieën om uw ervaring te verbeteren, site-gebruik te analyseren en te helpen bij onze marketinginspanningen. Door op "Accepteren" te klikken, stemt u in met ons gebruik van cookies voor analyses en sessieregistratie om onze service te verbeteren.';
  CookieConsentDetails = 'Wij gebruiken PostHog voor privacygerichte analyses. Geen gegevens worden verkocht aan derden. U kunt uw toestemming op elk moment intrekken in uw profielinstellingen.';
  CookieConsentAccept = 'Accepteren';
  CookieConsentDecline = 'Weigeren';

  PaletteMismatchError = 'Kralen van verschillende kralentypes kunnen niet gemengd worden. Dit patroon gebruikt {0}.';

  NewPatternBeadType = 'Kralentype';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Afmetingen gebaseerd op Miyuki Delica 11/0 kralen (~1,6×1,35 mm). Metingen zijn bij benadering.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Afmetingen gebaseerd op Preciosa Rocailles 11/0 kralen (~2,1 mm). Metingen zijn bij benadering.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

export class TranslationPortuguese implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Criador de Padrões de Contas é uma ferramenta gratuita para criar padrões de contas a partir de suas imagens. Carregue uma imagem, escolha sua paleta de cores e converta-a em um padrão de contas. Você pode editar o padrão, ajustar as cores e exportá-lo como PDF. O aplicativo suporta várias paletas de contas como Perler, Hama, Artkal e muito mais.";
  File = 'Arquivo';
  Edit = 'Editar';
  View = 'Ver';
  Image = 'Imagem';
  Help = 'Ajuda';
  About = 'Sobre';
  Warning = 'Aviso';
  ConfirmUnsavedPattern = 'O padrão atual não está salvo. Tem certeza de que deseja continuar?';
  Tools = 'Ferramentas';
  Name = 'Nome';
  Description = 'Descrição';
  Category = 'Categoria';
  AddCategory = 'Adicionar Categoria';
  EditCategory = 'Editar Categoria';
  DeleteCategory = 'Excluir Categoria';
  Ok = 'OK';
  Cancel = 'Cancelar';
  ConfirmDelete = 'Tem certeza de que deseja excluir {0}?';
  AddPattern = 'Adicionar Padrão';
  EditPattern = 'Editar Padrão';
  PaletteEditor = 'Editor de Paleta';
  SelectPaletteToEdit = 'Selecione a paleta para editar';
  NewPalette = 'Nova Paleta';
  DeletePalette = 'Excluir Paleta';
  MyPalette = 'Minha Paleta';
  SelectACategory = 'Categoria';
  SearchPattern = 'Padrão';
  DeletePattern = 'Excluir Padrão';
  OpenPattern = 'Abrir padrão...';
  SavePattern = 'Salvar padrão...';
  PrintPattern = 'Imprimir Padrão';
  BeadsPalette = 'Paleta de Contas';
  BeadNumber = 'Conta #';
  Count = 'Contagem';
  Print = 'Imprimir...';
  ExportPDF = 'Exportar PDF';
  Close = 'Fechar';
  WordChart = 'Gráfico de Palavras';
  ReplaceBeadWith = 'Substituir Conta por...';
  Apply = 'Aplicar';
  TransferImage = 'Transferir Imagem...';
  SelectPalette = 'Selecionar paleta...';
  Colors = 'Cores';
  PaletteNameEdit = 'Nome da Paleta (Editar)';
  OnlyFirstNBeadPalettes = 'Apenas as primeiras {0} paletas de contas';
  Filter = 'Filtrar...';
  Add = 'Adicionar';
  Remove = 'Remover';
  New = 'Novo';
  Open = 'Abrir';
  Save = 'Salvar';
  SaveAs = 'Salvar como...';
  Undo = 'Desfazer';
  Redo = 'Refazer';
  ZoomIn = 'Ampliar';
  ZoomOut = 'Reduzir';
  InsertImage = 'Inserir Imagem';
  InsertImageTooltip = 'Escolher Foto (Tire primeiro uma foto com o aplicativo de câmera e selecione-a da galeria)';
  ShiftPatternLeft = 'Deslocar Padrão para a Esquerda';
  ShiftPatternRight = 'Deslocar Padrão para a Direita';
  ShiftPatternUp = 'Deslocar Padrão para Cima';
  ShiftPatternDown = 'Deslocar Padrão para Baixo';
  RotatePatternLeft = 'Rotacionar Padrão para a Esquerda';
  RotatePatternRight = 'Rotacionar Padrão para a Direita';
  FlipPatternVertically = 'Virar Padrão Verticalmente';
  FlipPatternHorizontally = 'Virar Padrão Horizontalmente';
  All = 'Todos';
  AllPatterns = 'Todos os padrões';
  ShowHideImage = 'Mostrar/Ocultar Imagem';
  RotateImageLeft = 'Rotacionar Imagem para a Esquerda';
  RotateImageRight = 'Rotacionar Imagem para a Direita';
  RotateRight = 'Rotacionar para a Direita';
  RotateLeft = 'Rotacionar para a Esquerda';
  PreEffect = 'Pré Efeito';
  Method = 'Método';
  Dither = 'Dither';
  ShowSidebar = 'Mostrar Barra Lateral';
  HideSidebar = 'Ocultar Barra Lateral';
  TransformPattern = 'Transformar Padrão';
  AddBead = 'Adicionar Conta';
  Fill = 'Preencher';
  RemoveBead = 'Remover Conta';
  RemoveFill = 'Remover Preenchimento';
  PickBead = 'Escolher Conta';
  Pan = 'Panorâmica';
  Profile = 'Perfil';
  UnitOfMeasure = 'Unidade de medida';
  Inch = 'polegada';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Linhas';
  Columns = 'Colunas';
  Stitch = 'Ponto';
  Pattern = 'Padrão';
  Palettes = 'Paletas';
  Login = 'Entrar';
  NotSignedIn = 'Não conectado';
  SignInWith = 'Entrar com';
  LoginWithFacebook = 'Entrar com Facebook';
  LoginWithGoogle = 'Entrar com Google';
  RotatedPatternOn = 'Padrão Rotacionado (Ligado)';
  RotatedPatternOff = 'Padrão Rotacionado (Desligado)';
  SignOut = 'Sair';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'ESCOLHER';
  ChoosePlan = 'Escolher plano';
  ChangePlan = 'Alterar plano';
  ChangePlanDone = 'Plano alterado. Você pode ter que esperar alguns minutos para ver as alterações aplicadas.';
  Subscription = 'Assinatura';
  FREE = 'GRÁTIS';
  MONTHLY = 'MENSAL';
  YEARLY = 'ANUAL';
  SAVE20 = 'ECONOMIZE 20%';
  NoCharge = 'Sem custo';
  PlanFreeDescription1 = 'Salvar até 3 padrões';
  PlanFreeDescription2 = 'Sem Impressão / PDF';
  PlanPaidDescription1 = 'Padrões ilimitados';
  PlanPaidDescription2 = 'Impressão / PDF';
  BilledMonthly = 'Cobrado mensalmente';
  BilledAnnually = 'Cobrado anualmente';
  WelcomeTour = 'Tour de Boas-vindas';
  VideoTutorial = 'Tutorial em Vídeo';
  Previous = 'Anterior';
  Next = 'Próximo';
  Page = 'Página';
  SavePatternReminder = 'Não se esqueça de salvar seu padrão!';
  EarlyWarningBannerTitle = 'Você salvou 2 de 3 padrões gratuitos!';
  EarlyWarningBannerText = 'Atualize agora para padrões ilimitados e recursos premium.';
  ViewPlans = 'Ver Planos';
  PatternsUsed = '{0} de 3 padrões usados';
  PatternsRemaining = '({0} restantes)';
  JoinThousandsCreators = 'Junte-se a milhares de criadores em todo o mundo';
  TrialInfoBanner = 'Experimente o Pro gratuitamente por 7 dias. Cancele a qualquer momento durante o período de teste. Cartão necessário.';
  SevenDayFreeTrial = 'Teste Grátis de 7 Dias';
  TrialPlusTwoMonthsFree = 'TESTE GRÁTIS DE 7 DIAS + 2 MESES GRÁTIS';
  TwoMonthsFree = 'GANHE 2 MESES GRÁTIS';
  ThenMonthlyAfterTrial = 'Depois $5/mês após o teste';
  ThenYearlyAfterTrial = 'Depois apenas $4.17/mês após o teste';
  OnlyPricePerMonth = 'Apenas $4.17/mês';
  MostPopular = 'Mais Popular';
  SaveAmount = 'Economize $10/ano';
  UnlimitedPatterns = 'Padrões ilimitados';
  HDExport = 'Exportação HD (300 DPI)';
  PDFSavePrint = 'Salvar e imprimir PDF';
  PrioritySupport = 'Suporte prioritário';
  PatternReaderPaidFeature = 'Pattern Reader (economiza tempo + papel/tinta)';
  PrintPDF = 'Imprimir / PDF';
  StandardQuality = 'Qualidade padrão';
  NoPDFExport = 'Sem exportação PDF';
  EmailSupportOnly = 'Apenas suporte por e-mail';
  OnlyThreePatterns = 'Apenas 3 padrões';
  StartFreeTrial = 'Iniciar teste grátis';
  StartMonthlyPlan = 'Iniciar plano mensal';
  StartYearlyPlan = 'Iniciar plano anual';
  CurrentPlan = 'Plano atual';
  ContinueFree = 'Continuar Grátis';
  MoneyBackGuarantee = 'Garantia de 30 Dias';
  SecureCheckout = 'Checkout seguro';
  CancelAnytime = 'Cancele a qualquer momento';
  YourFreePlan = 'Seu Plano Grátis';
  FreePlanStatus = 'Plano Grátis';
  PatternsCreated = 'padrões';
  NoPDFPrinting = 'Sem PDF/Impressão';
  CreateBeautifulPatterns = 'Crie lindos padrões de contas em minutos';
  JoinThousandsCrafters = 'Junte-se a milhares de artistas de contas e artesãos em todo o mundo';
  AutoSaveDesigns = 'Salve automaticamente seus designs na nuvem';
  PrintProfessionalGuides = 'Imprima guias de padrão profissionais';
  AccessAnyDevice = 'Acesse de qualquer dispositivo';
  StartThreeFreePatterns = 'Comece com 3 padrões gratuitos';
  Initializing = 'Inicializando...';
  SignInWithGoogle = 'Entrar com Google';
  SecureAndPrivate = 'Seguro e Privado';
  NoCreditCardRequired = 'Nenhum cartão de crédito necessário';
  GetStarted = 'Começar';
  AwesomeAllSet = 'Incrível! Você está pronto!';
  YourPlan = 'Seu Plano';
  FreeTrial = 'Teste Grátis';
  DaysLeft = 'dias restantes';
  TrialEndsIn = 'O teste termina em';
  Day = 'dia';
  Days = 'dias';
  AllProFeaturesIncluded = 'Todos os recursos Pro incluídos';
  UnlimitedPatternsHDExport = 'Padrões ilimitados e exportação HD';
  ContinueWithPro = 'Continuar com Pro - A partir de $5/mês';
  KeepProBenefits = 'Mantenha todos os benefícios Pro após o término do teste';
  FreePlan = 'Plano Grátis';
  Active = 'Ativo';
  PatternUsage = 'Uso de Padrão';
  PatternRemaining = '{0} padrão{1} restante{1}';
  LimitReached = 'Limite atingido - Atualize para continuar';
  FreePlanLimited = 'Plano gratuito limitado a 3 padrões';
  UpgradeToPro = 'Atualizar para Pro ($5/mês)';
  ProPlan = 'Plano Pro';
  UnlimitedPatternsFeature = 'Padrões ilimitados';
  HDExportPrint = 'Exportação HD e Impressão';
  ManageSubscription = 'Gerenciar Assinatura';
  ManageSubscriptionHint = 'Atualizar pagamento, alterar plano ou cancelar';
  ProfileSettings = 'Configurações de Perfil';
  UsedAllFreePatterns = 'Você usou todos os 3 padrões gratuitos. Atualize agora para continuar criando!';
  OnePatternRemaining = 'Apenas 1 padrão gratuito restante. Atualize para padrões ilimitados!';
  Language = 'Idioma';
  NeedHelpCta = 'Precisa de ajuda?';
  HelpPanelTitle = 'Precisa de ajuda?';
  HelpPanelSubtitle = 'Obtenha ajuda sem sair do aplicativo.';
  HelpFaqHeading = 'Respostas rápidas';
  HelpContactHeading = 'Fale com o suporte';
  HelpContactDescription = 'Se encontrar um bug ou ficar preso, envie uma mensagem e responderemos rapidamente.';
  HelpContactEmailCta = 'Envie um e-mail para support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini tutorial';
  HelpTutorialDescription = 'Assista a um vídeo de 2 minutos sobre as principais ferramentas.';
  HelpClose = 'Fechar ajuda';
  HelpFaqUploadQuestion = 'Como envio minha foto de inspiração?';
  HelpFaqUploadAnswer = 'Clique em Imagem → Inserir imagem na barra de ferramentas. Você pode enviar qualquer foto e convertê-la em um padrão de miçangas.';
  HelpFaqSaveQuestion = 'Como salvo meu padrão?';
  HelpFaqSaveAnswer = 'Clique no botão Salvar na barra de ferramentas. Seus padrões são salvos automaticamente na sua conta e podem ser acessados a qualquer momento em Arquivo → Abrir padrão.';
  HelpFaqExportQuestion = 'Como posso exportar ou imprimir o padrão?';
  HelpFaqExportAnswer = 'Clique no botão Imprimir na barra de ferramentas para gerar PDFs em alta resolução com gráficos de miçangas, legendas de cores e listas de compras.';
  HelpFaqTutorialQuestion = 'Onde aprendo rapidamente as principais ferramentas?';
  HelpFaqTutorialAnswer = 'Toque no botão Vídeo Tutorial para ver um tour de dois minutos sobre envio, conversão e salvamento.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Ajuste as configurações acima, depois toque em Aplicar';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Toque Imagem → Inserir imagem';
  OnboardingHintTransferImage = 'Toque Imagem → Transferir imagem';
  OnboardingHintSave = 'Toque Arquivo → Salvar';

  // Welcome modal
  WelcomeModalTitle = 'Bem-vindo ao Bead Pattern Maker!';
  WelcomeModalSubtitle = 'Vamos criar seu primeiro padrão de contas a partir de uma imagem';
  WelcomeStep1Title = 'Envie Sua Imagem';
  WelcomeStep1Description = 'Escolha uma foto para converter';
  WelcomeStep2Title = 'Posicione e Converta';
  WelcomeStep2Description = 'Ajuste a imagem e converta em contas';
  WelcomeStep3Title = 'Salve Seu Padrão';
  WelcomeStep3Description = 'Guarde sua criação para uso futuro';
  WelcomeGuidanceNote = 'Vamos guiá-lo em cada etapa com dicas úteis';
  WelcomeShowMeHow = 'Mostre-me Como';
  WelcomeWatchDemo = 'Ver Demo Rápida';
  WelcomeExploreOwn = 'Vou Explorar Sozinho';

  // Onboarding checklist
  ChecklistGetStarted = 'Começar';
  ChecklistMinimize = 'Minimizar';
  ChecklistCloseAndSkip = 'Fechar e pular tutorial';
  ChecklistAwesomeAllSet = '🎉 Incrível! Você está pronto!';
  ChecklistTapToOpen = 'Toque para abrir o menu';
  ChecklistMenuOpened = 'Toque no item destacado';
  ChecklistStepSignedIn = 'Conectado';
  ChecklistStepUploadImage = 'Enviar uma imagem';
  ChecklistStepConvertPattern = 'Converter em padrão';
  ChecklistStepSaveWork = 'Salvar seu trabalho';

  // Login page
  LoginPageTagline = 'Crie lindos padrões de contas em minutos';
  LoginPageSubtitle = 'Junte-se a milhares de artistas e artesãos de contas em todo o mundo';
  LoginFeatureAutoSave = 'Salve automaticamente seus designs na nuvem';
  LoginFeaturePrint = 'Imprima guias de padrões profissionais';
  LoginFeatureDevices = 'Acesse de qualquer dispositivo';
  LoginFeatureUnlimited = 'Crie padrões ilimitados';
  LoginInitializing = 'Inicializando...';
  LoginSignInGoogle = 'Entrar com Google';
  LoginGoogleLogoAlt = 'Logo do Google';
  LoginSecurePrivate = 'Seguro e Privado';
  LoginStartFreePatterns = 'Comece com 3 padrões gratuitos';
  LoginOneClick = 'Login com um clique — sem senhas';
  LoginInProgress = 'Entrando...';
  LoginCancelled = 'Login cancelado. Por favor, tente novamente.';
  LoginNetworkError = 'Não foi possível conectar ao Google. Verifique sua conexão com a internet.';
  LoginAuthError = 'Falha na autenticação. Por favor, tente novamente.';
  LoginGenericError = 'Algo deu errado. Por favor, tente novamente.';
  TryAgain = 'Tentar novamente';

  // New pattern setup modal
  NewPatternTitle = 'Planeje Seu Padrão';
  NewPatternIntro = 'Escolha um preset ou personalize o ponto e o tamanho da grade para seu padrão.';
  NewPatternQuickPreset = 'Preset Rápido (Opcional)';
  NewPatternCustomSize = 'Tamanho Personalizado';
  NewPatternPopularProjects = 'Projetos Populares';
  NewPatternStitch = 'Ponto';
  NewPatternColumns = 'Colunas';
  NewPatternRows = 'Linhas';
  NewPatternApproximateSize = 'Tamanho aproximado:';
  NewPatternDimensionsNote = 'Dimensões baseadas em contas Miyuki Delica 11/0 (~1,8-2,1 mm). As medidas são aproximadas.';
  NewPatternCancel = 'Cancelar';
  NewPatternStart = 'Começar';
  PresetClassicPeyoteBracelet = 'Pulseira Peyote Clássica';
  PresetLoomBookmark = 'Marcador Tear';
  PresetBrickEarringsPair = 'Par de Brincos Brick';
  PresetWidePeyoteCuff = 'Bracelete Peyote Largo';
  PresetSmallLoomPanel = 'Painel Tear Pequeno';
  PresetBrickPendant = 'Pingente Brick';

  // Position image guide modal
  PositionImageTitle = 'Posicione Sua Imagem';
  PositionImageCloseTooltip = 'Fechar';
  PositionImageHeading = 'Como Posicionar Sua Imagem';
  PositionImageDragTitle = 'Arraste para Mover:';
  PositionImageDragDesc = 'Clique e arraste a imagem para posicioná-la sobre a grade de contas';
  PositionImageResizeTitle = 'Redimensionar:';
  PositionImageResizeDesc = 'Arraste as alças das pontas para aumentar ou diminuir sua imagem';
  PositionImageRotateTitle = 'Girar:';
  PositionImageRotateDesc = 'Use os botões da barra de ferramentas para girar sua imagem, se necessário';
  PositionImageTipLabel = 'Dica:';
  PositionImageTipText = 'Posicione sua imagem para cobrir a área que deseja converter em contas';
  PositionImageReady = 'Quando estiver pronto, clique no botão Transferir Imagem (⚡) na barra de ferramentas';
  PositionImageGotIt = 'Entendi!';

  // Video player modal
  VideoPlayerCloseAria = 'Fechar vídeo';
  VideoPlayerNotSupported = 'Seu navegador não suporta a tag de vídeo.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Valorizamos sua privacidade';
  CookieConsentMessage = 'Usamos cookies e tecnologias semelhantes para melhorar sua experiência, analisar o uso do site e ajudar em nossos esforços de marketing. Ao clicar em "Aceitar", você consente com o uso de cookies para análises e gravação de sessão para nos ajudar a melhorar nosso serviço.';
  CookieConsentDetails = 'Usamos PostHog para análises focadas em privacidade. Nenhum dado é vendido a terceiros. Você pode retirar o consentimento a qualquer momento nas configurações do seu perfil.';
  CookieConsentAccept = 'Aceitar';
  CookieConsentDecline = 'Recusar';

  PaletteMismatchError = 'Não é possível misturar miçangas de tipos diferentes. Este padrão utiliza {0}.';

  NewPatternBeadType = 'Tipo de Conta';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Dimensões baseadas em contas Miyuki Delica 11/0 (~1,6×1,35 mm). As medidas são aproximadas.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Dimensões baseadas em contas Preciosa Rocailles 11/0 (~2,1 mm). As medidas são aproximadas.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}

export class TranslationPolish implements ITranslation {
  AppName = 'Bead Pattern Maker';
  AppDescription = "Kreator Wzorów z Koralików to darmowe narzędzie do tworzenia wzorów z koralików z Twoich obrazów. Prześlij obraz, wybierz paletę kolorów i przekonwertuj go na wzór z koralików. Możesz edytować wzór, dostosować kolory i wyeksportować jako PDF. Aplikacja obsługuje wiele palet koralików, takich jak Perler, Hama, Artkal i inne.";
  File = 'Plik';
  Edit = 'Edytuj';
  View = 'Widok';
  Image = 'Obraz';
  Help = 'Pomoc';
  About = 'O programie';
  Warning = 'Ostrzeżenie';
  ConfirmUnsavedPattern = 'Bieżący wzór nie jest zapisany. Czy na pewno chcesz kontynuować?';
  Tools = 'Narzędzia';
  Name = 'Nazwa';
  Description = 'Opis';
  Category = 'Kategoria';
  AddCategory = 'Dodaj Kategorię';
  EditCategory = 'Edytuj Kategorię';
  DeleteCategory = 'Usuń Kategorię';
  Ok = 'OK';
  Cancel = 'Anuluj';
  ConfirmDelete = 'Czy na pewno chcesz usunąć {0}?';
  AddPattern = 'Dodaj Wzór';
  EditPattern = 'Edytuj Wzór';
  PaletteEditor = 'Edytor Palety';
  SelectPaletteToEdit = 'Wybierz paletę do edycji';
  NewPalette = 'Nowa Paleta';
  DeletePalette = 'Usuń Paletę';
  MyPalette = 'Moja Paleta';
  SelectACategory = 'Kategoria';
  SearchPattern = 'Wzór';
  DeletePattern = 'Usuń Wzór';
  OpenPattern = 'Otwórz wzór...';
  SavePattern = 'Zapisz wzór...';
  PrintPattern = 'Drukuj Wzór';
  BeadsPalette = 'Paleta Koralików';
  BeadNumber = 'Koralik #';
  Count = 'Liczba';
  Print = 'Drukuj...';
  ExportPDF = 'Eksportuj PDF';
  Close = 'Zamknij';
  WordChart = 'Wykres Słowny';
  ReplaceBeadWith = 'Zastąp Koralik...';
  Apply = 'Zastosuj';
  TransferImage = 'Przenieś Obraz...';
  SelectPalette = 'Wybierz paletę...';
  Colors = 'Kolory';
  PaletteNameEdit = 'Nazwa Palety (Edytuj)';
  OnlyFirstNBeadPalettes = 'Tylko pierwsze {0} palety koralików';
  Filter = 'Filtruj...';
  Add = 'Dodaj';
  Remove = 'Usuń';
  New = 'Nowy';
  Open = 'Otwórz';
  Save = 'Zapisz';
  SaveAs = 'Zapisz jako...';
  Undo = 'Cofnij';
  Redo = 'Ponów';
  ZoomIn = 'Powiększ';
  ZoomOut = 'Pomniejsz';
  InsertImage = 'Wstaw Obraz';
  InsertImageTooltip = 'Wybierz Zdjęcie (Najpierw zrób zdjęcie aparatem, a następnie wybierz je z galerii)';
  ShiftPatternLeft = 'Przesuń Wzór w Lewo';
  ShiftPatternRight = 'Przesuń Wzór w Prawo';
  ShiftPatternUp = 'Przesuń Wzór w Górę';
  ShiftPatternDown = 'Przesuń Wzór w Dół';
  RotatePatternLeft = 'Obróć Wzór w Lewo';
  RotatePatternRight = 'Obróć Wzór w Prawo';
  FlipPatternVertically = 'Odwróć Wzór Pionowo';
  FlipPatternHorizontally = 'Odwróć Wzór Poziomo';
  All = 'Wszystkie';
  AllPatterns = 'Wszystkie wzory';
  ShowHideImage = 'Pokaż/Ukryj Obraz';
  RotateImageLeft = 'Obróć Obraz w Lewo';
  RotateImageRight = 'Obróć Obraz w Prawo';
  RotateRight = 'Obróć w Prawo';
  RotateLeft = 'Obróć w Lewo';
  PreEffect = 'Efekt Wstępny';
  Method = 'Metoda';
  Dither = 'Dither';
  ShowSidebar = 'Pokaż Pasek Boczny';
  HideSidebar = 'Ukryj Pasek Boczny';
  TransformPattern = 'Przekształć Wzór';
  AddBead = 'Dodaj Koralik';
  Fill = 'Wypełnij';
  RemoveBead = 'Usuń Koralik';
  RemoveFill = 'Usuń Wypełnienie';
  PickBead = 'Wybierz Koralik';
  Pan = 'Przesuwanie';
  Profile = 'Profil';
  UnitOfMeasure = 'Jednostka miary';
  Inch = 'cal';
  Cm = 'cm';
  Mm = 'mm';
  Rows = 'Wiersze';
  Columns = 'Kolumny';
  Stitch = 'Ścieg';
  Pattern = 'Wzór';
  Palettes = 'Palety';
  Login = 'Zaloguj';
  NotSignedIn = 'Nie zalogowano';
  SignInWith = 'Zaloguj się przez';
  LoginWithFacebook = 'Zaloguj przez Facebook';
  LoginWithGoogle = 'Zaloguj przez Google';
  RotatedPatternOn = 'Obrócony Wzór (Włączony)';
  RotatedPatternOff = 'Obrócony Wzór (Wyłączony)';
  SignOut = 'Wyloguj';
  Facebook = 'Facebook';
  Google = 'Google';
  Choose = 'WYBIERZ';
  ChoosePlan = 'Wybierz plan';
  ChangePlan = 'Zmień plan';
  ChangePlanDone = 'Plan zmieniony. Może minąć kilka minut, zanim zmiany zostaną zastosowane.';
  Subscription = 'Subskrypcja';
  FREE = 'DARMOWY';
  MONTHLY = 'MIESIĘCZNY';
  YEARLY = 'ROCZNY';
  SAVE20 = 'OSZCZĘDŹ 20%';
  NoCharge = 'Bez opłat';
  PlanFreeDescription1 = 'Zapisz do 3 wzorów';
  PlanFreeDescription2 = 'Brak Druku / PDF';
  PlanPaidDescription1 = 'Nieograniczone wzory';
  PlanPaidDescription2 = 'Druk / PDF';
  BilledMonthly = 'Rozliczane miesięcznie';
  BilledAnnually = 'Rozliczane rocznie';
  WelcomeTour = 'Wycieczka Powitalna';
  VideoTutorial = 'Samouczek Wideo';
  Previous = 'Poprzedni';
  Next = 'Następny';
  Page = 'Strona';
  SavePatternReminder = 'Nie zapomnij zapisać swojego wzoru!';
  EarlyWarningBannerTitle = 'Zapisałeś 2 z 3 darmowych wzorów!';
  EarlyWarningBannerText = 'Ulepsz teraz, aby uzyskać nieograniczone wzory i funkcje premium.';
  ViewPlans = 'Zobacz Plany';
  PatternsUsed = '{0} z 3 wzorów użytych';
  PatternsRemaining = '({0} pozostało)';
  JoinThousandsCreators = 'Dołącz do tysięcy twórców na całym świecie';
  TrialInfoBanner = 'Wypróbuj Pro za darmo przez 7 dni. Anuluj w dowolnym momencie podczas okresu próbnego. Wymagana karta.';
  SevenDayFreeTrial = '7-Dniowy Darmowy Okres Próbny';
  TrialPlusTwoMonthsFree = '7-DNIOWY DARMOWY OKRES PRÓBNY + 2 MIESIĄCE DARMOWE';
  TwoMonthsFree = 'ZYSKAJ 2 MIESIĄCE DARMOWE';
  ThenMonthlyAfterTrial = 'Następnie $5/miesiąc po okresie próbnym';
  ThenYearlyAfterTrial = 'Następnie tylko $4.17/miesiąc po okresie próbnym';
  OnlyPricePerMonth = 'Tylko $4.17/miesiąc';
  MostPopular = 'Najpopularniejsze';
  SaveAmount = 'Zaoszczędź $10/rok';
  UnlimitedPatterns = 'Nieograniczone wzory';
  HDExport = 'Eksport HD (300 DPI)';
  PDFSavePrint = 'Zapisz i drukuj PDF';
  PrioritySupport = 'Priorytetowe wsparcie';
  PatternReaderPaidFeature = 'Pattern Reader (oszczedza czas + papier/tusz)';
  PrintPDF = 'Druk / PDF';
  StandardQuality = 'Standardowa jakość';
  NoPDFExport = 'Brak eksportu PDF';
  EmailSupportOnly = 'Tylko wsparcie e-mail';
  OnlyThreePatterns = 'Tylko 3 wzory';
  StartFreeTrial = 'Rozpocznij darmowy okres próbny';
  StartMonthlyPlan = 'Rozpocznij plan miesięczny';
  StartYearlyPlan = 'Rozpocznij plan roczny';
  CurrentPlan = 'Bieżący plan';
  ContinueFree = 'Kontynuuj Darmowy';
  MoneyBackGuarantee = '30-Dniowa Gwarancja Zwrotu Pieniędzy';
  SecureCheckout = 'Bezpieczne zamówienie';
  CancelAnytime = 'Anuluj w dowolnym momencie';
  YourFreePlan = 'Twój Darmowy Plan';
  FreePlanStatus = 'Plan Darmowy';
  PatternsCreated = 'wzory';
  NoPDFPrinting = 'Bez PDF/Druku';
  CreateBeautifulPatterns = 'Twórz piękne wzory z koralików w kilka minut';
  JoinThousandsCrafters = 'Dołącz do tysięcy artystów koralików i rzemieślników na całym świecie';
  AutoSaveDesigns = 'Automatycznie zapisuj swoje projekty w chmurze';
  PrintProfessionalGuides = 'Drukuj profesjonalne przewodniki wzorów';
  AccessAnyDevice = 'Dostęp z dowolnego urządzenia';
  StartThreeFreePatterns = 'Zacznij od 3 darmowych wzorów';
  Initializing = 'Inicjalizowanie...';
  SignInWithGoogle = 'Zaloguj się przez Google';
  SecureAndPrivate = 'Bezpieczne i Prywatne';
  NoCreditCardRequired = 'Nie wymagana karta kredytowa';
  GetStarted = 'Zacznij';
  AwesomeAllSet = 'Świetnie! Wszystko gotowe!';
  YourPlan = 'Twój Plan';
  FreeTrial = 'Darmowy Okres Próbny';
  DaysLeft = 'dni pozostało';
  TrialEndsIn = 'Okres próbny kończy się za';
  Day = 'dzień';
  Days = 'dni';
  AllProFeaturesIncluded = 'Wszystkie funkcje Pro włączone';
  UnlimitedPatternsHDExport = 'Nieograniczone wzory i eksport HD';
  ContinueWithPro = 'Kontynuuj z Pro - Od $5/miesiąc';
  KeepProBenefits = 'Zachowaj wszystkie korzyści Pro po zakończeniu okresu próbnego';
  FreePlan = 'Darmowy Plan';
  Active = 'Aktywny';
  PatternUsage = 'Użycie Wzoru';
  PatternRemaining = '{0} wzór{1} pozostało';
  LimitReached = 'Osiągnięto limit - Ulepsz, aby kontynuować';
  FreePlanLimited = 'Darmowy plan ograniczony do 3 wzorów';
  UpgradeToPro = 'Ulepsz do Pro ($5/mies.)';
  ProPlan = 'Plan Pro';
  UnlimitedPatternsFeature = 'Nieograniczone wzory';
  HDExportPrint = 'Eksport HD i Druk';
  ManageSubscription = 'Zarządzaj Subskrypcją';
  ManageSubscriptionHint = 'Zaktualizuj płatność, zmień plan lub anuluj';
  ProfileSettings = 'Ustawienia Profilu';
  UsedAllFreePatterns = 'Użyłeś wszystkich 3 darmowych wzorów. Ulepsz teraz, aby kontynuować tworzenie!';
  OnePatternRemaining = 'Pozostał tylko 1 darmowy wzór. Ulepsz, aby uzyskać nieograniczone wzory!';
  Language = 'Język';
  NeedHelpCta = 'Potrzebujesz pomocy?';
  HelpPanelTitle = 'Potrzebujesz pomocy?';
  HelpPanelSubtitle = 'Uzyskaj pomoc bez opuszczania aplikacji.';
  HelpFaqHeading = 'Szybkie odpowiedzi';
  HelpContactHeading = 'Skontaktuj się z supportem';
  HelpContactDescription = 'Jeśli natrafisz na błąd lub utkniesz, napisz do nas – szybko pomożemy.';
  HelpContactEmailCta = 'Napisz na support@beadpatternmaker.com';
  HelpTutorialHeading = 'Mini poradnik';
  HelpTutorialDescription = 'Obejrzyj 2‑minutowy film o najważniejszych narzędziach.';
  HelpClose = 'Zamknij pomoc';
  HelpFaqUploadQuestion = 'Jak wgrać moje zdjęcie inspiracji?';
  HelpFaqUploadAnswer = 'Kliknij Obraz → Wstaw obraz na pasku narzędzi. Możesz wgrać dowolne zdjęcie i przekonwertować je na wzór koralików.';
  HelpFaqSaveQuestion = 'Jak zapisać mój wzór?';
  HelpFaqSaveAnswer = 'Kliknij przycisk Zapisz na pasku narzędzi. Twoje wzory są automatycznie zapisywane na koncie i można je otworzyć w każdej chwili z menu Plik → Otwórz wzór.';
  HelpFaqExportQuestion = 'Jak mogę wyeksportować lub wydrukować wzór?';
  HelpFaqExportAnswer = 'Kliknij przycisk Drukuj na pasku narzędzi, aby wygenerować PDF-y w wysokiej rozdzielczości z wykresami koralików, legendami kolorów i listami zakupów.';
  HelpFaqTutorialQuestion = 'Gdzie szybko poznam najważniejsze narzędzia?';
  HelpFaqTutorialAnswer = 'Kliknij przycisk Samouczek wideo poniżej, aby zobaczyć dwuminutowy przegląd przesyłania, konwersji i zapisywania.';

  // Onboarding hints
  OnboardingHintAdjustSettings = '⚙️ Dostosuj ustawienia powyżej, następnie dotknij Zastosuj';
  OnboardingHintGotIt = 'OK';
  OnboardingHintUploadImage = 'Dotknij Obraz → Wstaw obraz';
  OnboardingHintTransferImage = 'Dotknij Obraz → Przenieś obraz';
  OnboardingHintSave = 'Dotknij Plik → Zapisz';

  // Welcome modal
  WelcomeModalTitle = 'Witaj w Bead Pattern Maker!';
  WelcomeModalSubtitle = 'Stwórzmy Twój pierwszy wzór koralików z obrazu';
  WelcomeStep1Title = 'Prześlij Swój Obraz';
  WelcomeStep1Description = 'Wybierz zdjęcie do konwersji';
  WelcomeStep2Title = 'Ustaw i Konwertuj';
  WelcomeStep2Description = 'Dopasuj obraz i przekonwertuj na koraliki';
  WelcomeStep3Title = 'Zapisz Swój Wzór';
  WelcomeStep3Description = 'Zachowaj swoją kreację na przyszłość';
  WelcomeGuidanceNote = 'Poprowadzimy Cię przez każdy krok z pomocnymi wskazówkami';
  WelcomeShowMeHow = 'Pokaż Mi Jak';
  WelcomeWatchDemo = 'Zobacz Szybkie Demo';
  WelcomeExploreOwn = 'Sam Się Rozejrzę';

  // Onboarding checklist
  ChecklistGetStarted = 'Rozpocznij';
  ChecklistMinimize = 'Minimalizuj';
  ChecklistCloseAndSkip = 'Zamknij i pomiń samouczek';
  ChecklistAwesomeAllSet = '🎉 Świetnie! Jesteś gotowy!';
  ChecklistTapToOpen = 'Dotknij, aby otworzyć menu';
  ChecklistMenuOpened = 'Dotknij podświetlonego elementu';
  ChecklistStepSignedIn = 'Zalogowany';
  ChecklistStepUploadImage = 'Prześlij obraz';
  ChecklistStepConvertPattern = 'Konwertuj na wzór';
  ChecklistStepSaveWork = 'Zapisz swoją pracę';

  // Login page
  LoginPageTagline = 'Twórz piękne wzory z koralików w kilka minut';
  LoginPageSubtitle = 'Dołącz do tysięcy artystów i rzemieślników z koralików na całym świecie';
  LoginFeatureAutoSave = 'Automatycznie zapisuj swoje projekty w chmurze';
  LoginFeaturePrint = 'Drukuj profesjonalne przewodniki wzorów';
  LoginFeatureDevices = 'Dostęp z dowolnego urządzenia';
  LoginFeatureUnlimited = 'Twórz nieograniczoną liczbę wzorów';
  LoginInitializing = 'Inicjalizacja...';
  LoginSignInGoogle = 'Zaloguj się przez Google';
  LoginGoogleLogoAlt = 'Logo Google';
  LoginSecurePrivate = 'Bezpieczne i Prywatne';
  LoginStartFreePatterns = 'Zacznij od 3 darmowych wzorów';
  LoginOneClick = 'Logowanie jednym kliknięciem — bez hasła';
  LoginInProgress = 'Logowanie...';
  LoginCancelled = 'Logowanie anulowane. Spróbuj ponownie.';
  LoginNetworkError = 'Nie można połączyć się z Google. Sprawdź połączenie internetowe.';
  LoginAuthError = 'Uwierzytelnianie nie powiodło się. Spróbuj ponownie.';
  LoginGenericError = 'Coś poszło nie tak. Spróbuj ponownie.';
  TryAgain = 'Spróbuj ponownie';

  // New pattern setup modal
  NewPatternTitle = 'Zaplanuj Swój Wzór';
  NewPatternIntro = 'Wybierz szablon lub dostosuj ścieg i rozmiar siatki dla swojego wzoru.';
  NewPatternQuickPreset = 'Szybki Szablon (Opcjonalnie)';
  NewPatternCustomSize = 'Niestandardowy Rozmiar';
  NewPatternPopularProjects = 'Popularne Projekty';
  NewPatternStitch = 'Ścieg';
  NewPatternColumns = 'Kolumny';
  NewPatternRows = 'Wiersze';
  NewPatternApproximateSize = 'Przybliżony rozmiar:';
  NewPatternDimensionsNote = 'Wymiary oparte na koralkach Miyuki Delica 11/0 (~1,8-2,1 mm). Pomiary są przybliżone.';
  NewPatternCancel = 'Anuluj';
  NewPatternStart = 'Rozpocznij';
  PresetClassicPeyoteBracelet = 'Klasyczna Bransoletka Peyote';
  PresetLoomBookmark = 'Zakładka Krosno';
  PresetBrickEarringsPair = 'Para Kolczyków Brick';
  PresetWidePeyoteCuff = 'Szeroka Opaska Peyote';
  PresetSmallLoomPanel = 'Mały Panel Krosno';
  PresetBrickPendant = 'Wisiorek Brick';

  // Position image guide modal
  PositionImageTitle = 'Ustaw Swój Obraz';
  PositionImageCloseTooltip = 'Zamknij';
  PositionImageHeading = 'Jak Ustawić Swój Obraz';
  PositionImageDragTitle = 'Przeciągnij, aby Przesunąć:';
  PositionImageDragDesc = 'Kliknij i przeciągnij obraz, aby umieścić go nad siatką koralików';
  PositionImageResizeTitle = 'Zmień Rozmiar:';
  PositionImageResizeDesc = 'Przeciągnij uchwyty narożników, aby powiększyć lub zmniejszyć obraz';
  PositionImageRotateTitle = 'Obróć:';
  PositionImageRotateDesc = 'Użyj przycisków na pasku narzędzi, aby obrócić obraz w razie potrzeby';
  PositionImageTipLabel = 'Wskazówka:';
  PositionImageTipText = 'Ustaw obraz tak, aby obejmował obszar, który chcesz przekonwertować na koraliki';
  PositionImageReady = 'Gdy będziesz gotowy, kliknij przycisk Przenieś Obraz (⚡) na pasku narzędzi';
  PositionImageGotIt = 'Rozumiem!';

  // Video player modal
  VideoPlayerCloseAria = 'Zamknij wideo';
  VideoPlayerNotSupported = 'Twoja przeglądarka nie obsługuje tagu wideo.';

  // Cookie consent / Privacy
  CookieConsentTitle = 'Cenimy Twoją prywatność';
  CookieConsentMessage = 'Używamy plików cookie i podobnych technologii, aby poprawić Twoje doświadczenia, analizować korzystanie z witryny i wspierać nasze działania marketingowe. Klikając "Akceptuj", wyrażasz zgodę na nasze użycie plików cookie do analityki i nagrywania sesji, aby pomóc nam ulepszyć naszą usługę.';
  CookieConsentDetails = 'Używamy PostHog do analiz skoncentrowanych na prywatności. Żadne dane nie są sprzedawane stronom trzecim. Możesz wycofać zgodę w każdej chwili w ustawieniach profilu.';
  CookieConsentAccept = 'Akceptuj';
  CookieConsentDecline = 'Odrzuć';

  PaletteMismatchError = 'Nie można mieszać koralików różnych typów. Ten wzór używa {0}.';

  NewPatternBeadType = 'Typ Koralika';
  BeadTypeMiyukiDelica = 'Miyuki Delica 11/0';
  BeadTypeMiyukiDelicaNote = 'Wymiary oparte na koralkach Miyuki Delica 11/0 (~1,6×1,35 mm). Pomiary są przybliżone.';
  BeadTypePreciosaRocailles = 'Preciosa Rocailles 11/0';
  BeadTypePreciosaRocaillesNote = 'Wymiary oparte na koralkach Preciosa Rocailles 11/0 (~2,1 mm). Pomiary są przybliżone.';

  PatternReader = 'Pattern Reader';
  ReaderSettings = 'Reader Settings';
  ReaderColorLegend = 'Color Legend';
  ReaderPreviewTitle = 'Preview Mode';
  ReaderPreviewMessage = 'Upgrade to unlock the full reader, all rows, and text-to-speech playback.';
  ReaderUpgradeCta = 'Upgrade Now';
  ReaderTtsUnsupported = 'Text-to-speech is not supported in this browser. Navigation still works.';
  ReaderWaitPerBead = 'Wait Per Bead';
  ReaderLanguage = 'Voice Language';
  ReaderPlay = 'Play';
  ReaderPause = 'Pause';
  ReaderStop = 'Stop';
  ReaderReset = 'Reset';
  ReaderRow = 'Row';
  ReaderKeyboardHint = 'Keyboard: Space • ← → • Enter (skip) • Home • Esc';
  ReaderSkipWait = 'Skip';
  ReaderNoRows = 'No word chart rows available.';
}
